import React, { useState, useRef, useEffect } from 'react'
import Select from 'react-select'
import CheckboxComponent from '../../CommonComponents/CheckboxComponent'
import { Radio, RadioGroup } from 'rsuite';
import DragDropFileUpload from '../../CommonComponents/DragDropFileUpload'
import VisaImg from '../../../assets/svg/accept-visa-image.svg'
import MasterCardImg from '../../../assets/svg/accept-mastercard-image.svg'
import AmexImg from '../../../assets/svg/accept-amex-image.svg'
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { AiOutlinePlusCircle } from 'react-icons/ai'
import { toast } from '../../CommonComponents/ToastComponent/toast'
import ThreeStateToggleButton from '../../CommonComponents/ThreeStateToggleButton'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { Loader } from 'rsuite';
import AdvanceAcceptanceDetailsModal from './advance-acceptance-details-modal'
import ToggleButton from '../../CommonComponents/ToggleButton'
import { checkCardsFeeIdentical } from '../../../services/checkCardFeeIdentical'
import { MdOutlineChangeCircle } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { getExistingContacts } from '../../../redux/actions/contact';
import ContactView from '../../ContactsComponent/contactView';
import AllContacts from '../../ContactsComponent/allContacts';
import ModalComponent from '../../CommonComponents/Modal';
import CreateContact from '../../ContactsComponent/createContact';
import { store } from '../../../redux/store';

const CreateMasterCardTab = ({ columns, cardInfo, onChangeCardInfo, onChangeCardAuthorizationFormFile, cardAuthorizationFormFile, onAddEmails, onPrimaryCardEmail, supplierPrimaryCardEmail, addedEmailValues, onAddedEmails, childCardInfo, cardEmailType, isPhoneValid, isValidatingPhone, isIVRPhoneValid, isValidatingIVRPhone, handleCardPhoneNumberFocusOut, handleCardEmailFocusOut, isEmailValid, isValidatingEmail, cardFeeInfo, onUpdateCardFeeInfo, onUpdateDeliveryMethodsFeeValues, deliveryMethodsFeeValues, countryCode, showAcceptancePerCard, accPerCardText, genericFeeValues, onChangeGenericFeeInfo, isFromList, onCardConditionsChange, setAllContacts, allContacts }) => {
  const dispatch = useDispatch()
  const showAmex = cardInfo['isAcceptAmericanExpress']?.value
  const showVisa = cardInfo['isAcceptVisa']?.value
  const showMaster = cardInfo['isAcceptMasterCard']?.value
  const showDiscover = cardInfo['isAcceptDiscover']?.value
  const showChildAmex = childCardInfo['isAcceptAmericanExpress']?.value
  const showChildVisa = childCardInfo['isAcceptVisa']?.value
  const showChildMaster = childCardInfo['isAcceptMasterCard']?.value
  const showChildDiscover = childCardInfo['isAcceptDiscover']?.value
  const phoneInputRefname = useRef(null);
  const ivrPhoneInputRefname = useRef(null);
  const isEmailSelected = cardInfo[columns[29].name].value ? 1 : 0
  const isPhoneSelected = cardInfo[columns[30].name].value ? 1 : 0
  const isFaxSelected = cardInfo[columns[31].name].value ? 1 : 0
  const isOnlineSelected = cardInfo[columns[32].name].value ? 1 : 0
  const isPosSelected = cardInfo[columns[41].name].value ? 1 : 0
  const childCardData = {}

  Object.keys(childCardInfo).forEach(key => {
    if (key === 'productSpecificOptions') {
      const cardProductSpecificOptions = childCardInfo[key]?.map(option => option?.value)?.join(",")
      childCardData[key] = cardProductSpecificOptions
    } else {
      childCardData[key] = childCardInfo[key]?.value
    }
  })

  const showChildAcceptancePerCard = !showAcceptancePerCard ? !checkCardsFeeIdentical(childCardData) : true // to check that Accepts all cards and fee for all cards is identical or not
  const totalDeliveryMethods = isEmailSelected + isPhoneSelected + isFaxSelected + isOnlineSelected + isPosSelected
  const paymentTermsOptions = [...Array(91)].map((_, i) => i);
  const product_specific_options = ['Parts and services', 'Taxes', 'Utilities', 'Subscriptions', 'Donations', 'Advertising', 'Insurance Premiums']
  const remit_requirements_options = ['Invoice number', 'Account number', 'Credentials', 'Full card Number', 'Card last four digit', 'Full address'];

  const deliveryMethodTabs = [
    cardInfo[columns[29].name]?.value && ({
      label: 'Email',
      value: 'email'
    }),
    cardInfo[columns[30].name]?.value && ({
      label: 'Phone',
      value: 'phone'
    }),
    cardInfo[columns[31].name]?.value && ({
      label: 'Fax',
      value: 'fax'
    }),
    cardInfo[columns[32].name]?.value && ({
      label: 'Online',
      value: 'online'
    }),
    cardInfo[columns[41].name]?.value && ({
      label: 'Point of sale',
      value: 'pos'
    }),
  ]

  var addEmailsObject = {}
  if (addedEmailValues.length > 0) {
    addedEmailValues.map((value, index) => {
      addEmailsObject[index] = value?.["extra-email-name-" + (index + 1)]
    })
  }

  const [suppliercardEmailsInfo, setSuppliercardEmailsInfo] = useState(supplierPrimaryCardEmail !== '' ? { 0: supplierPrimaryCardEmail } : {})
  const [emailValues, setEmailValues] = useState(addedEmailValues);
  const [addEmailValues, setAddEmailValues] = useState(addEmailsObject);
  const [showAdvanceAccDetailsModal, setShowAdvanceAccDetailsModal] = useState(false)
  const [deliveryMethodValues, setDeliveryMethodValues] = useState({
    email: false,
    phone: false,
    fax: false,
    online: false,
    pos: false,
  })
  const [deliveryMethodFeeValues, setDeliveryMethodFeeValues] = useState({})
  const [showAllContacts, setShowAllContacts] = useState({
    email: false,
    phone: false,
    ivrPhone: false
  })
  const [existedContacts, setExistedContacts] = useState([])
  const [isLoadingExistingContacts, setIsLoadingExistingContacts] = useState(false)
  const [currentContact, setCurrentContact] = useState({})
  const [showAddNewContact, setShowAddNewContact] = useState(false)
  const [contactDataFromField, setContactDataFromField] = useState({})

  const showAmexMinFee = cardFeeInfo?.showHideFee?.showAmexMinFee
  const showAmexMaxFee = cardFeeInfo?.showHideFee?.showAmexMaxFee
  const showAmexIncrementalFee = cardFeeInfo?.showHideFee?.showAmexIncrementalFee
  const showVisaMinFee = cardFeeInfo?.showHideFee?.showVisaMinFee
  const showVisaMaxFee = cardFeeInfo?.showHideFee?.showVisaMaxFee
  const showVisaIncrementalFee = cardFeeInfo?.showHideFee?.showVisaIncrementalFee
  const showMasterMinFee = cardFeeInfo?.showHideFee?.showMasterMinFee
  const showMasterMaxFee = cardFeeInfo?.showHideFee?.showMasterMaxFee
  const showMasterIncrementalFee = cardFeeInfo?.showHideFee?.showMasterIncrementalFee
  const showDiscoverMinFee = cardFeeInfo?.showHideFee?.showDiscoverMinFee
  const showDiscoverMaxFee = cardFeeInfo?.showHideFee?.showDiscoverMaxFee
  const showDiscoverIncrementalFee = cardFeeInfo?.showHideFee?.showDiscoverIncrementalFee
  const showMinFee = genericFeeValues?.showMinFee
  const showMaxFee = genericFeeValues?.showMaxFee
  const showIncrementalFee = genericFeeValues?.showIncrementalFee
  const showAmexSecondProcessingFee = cardFeeInfo?.showHideFee?.showAmexSecondProcessingFee
  const showVisaSecondProcessingFee = cardFeeInfo?.showHideFee?.showVisaSecondProcessingFee
  const showMasterSecondProcessingFee = cardFeeInfo?.showHideFee?.showMasterSecondProcessingFee
  const showDiscoverSecondProcessingFee = cardFeeInfo?.showHideFee?.showDiscoverSecondProcessingFee
  const showAnotherProcessingFee = genericFeeValues['showAnotherProcessingFee']

  useEffect(() => {
    if (supplierPrimaryCardEmail !== '') {
      setSuppliercardEmailsInfo({
        0: supplierPrimaryCardEmail
      })
    } else {
      setSuppliercardEmailsInfo({})
    }
  }, [supplierPrimaryCardEmail])

  const handleUpdateCardFeeInfo = (paymentName, value, type = 'showHideFee', feeValueColumnName, feeValueType = '') => {
    onUpdateCardFeeInfo(paymentName, value, type, feeValueColumnName, feeValueType)
  }

  const handleFileChosen = (file) => {
    if (
      !file
    ) {
      return
    }
    onChangeCardAuthorizationFormFile(file)
  }

  const addMoreEmail = async () => {
    if (Object.keys(suppliercardEmailsInfo).length > 0) {
      if (isEmailValid === false) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Email!'
        })
        return
      }
      if (suppliercardEmailsInfo?.[0]?.email && suppliercardEmailsInfo?.[0]?.email !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(suppliercardEmailsInfo?.[0]?.email)) {
        toast.show({
          title: 'Warning',
          description: 'Email Address must be in email format',
        })
        return
      }

      var addEmailValuesObject = {}
      if (Object.keys(addEmailValues).length > 0) {
        Object.keys(addEmailValues).map((key, index) => {
          addEmailValuesObject[key] = addEmailValues[key]?.email
        })
      }

      if (Object.values(addEmailValuesObject).includes(suppliercardEmailsInfo?.[0]?.email)) {
        toast.show({
          title: 'Warning',
          description: 'Email Address is already added!',
        })
        return
      }

      if (cardEmailType === '') {
        toast.show({
          title: 'Warning',
          description: 'Please choose the Email Type from dropdown!',
        })
        return
      }
      var isValidEmail = await handleCardEmailFocusOut(suppliercardEmailsInfo?.[0]?.email, true)
      if (isValidEmail?.valid) {
        var index = 'extra-email-name-' + (emailValues.length + 1)
        var index1 = Object.keys(addEmailValues).length
        let addedEmailFormValues = [...emailValues];
        let addEmailFormValues = { ...addEmailValues };
        setEmailValues([...emailValues, { [index]: { 'email': suppliercardEmailsInfo?.[0]?.email, 'emailType': cardEmailType, emailContactId: suppliercardEmailsInfo?.[0]?.emailContactId } }]);
        setAddEmailValues({ ...addEmailValues, [index1]: { 'email': suppliercardEmailsInfo?.[0]?.email, 'emailType': cardEmailType, emailContactId: suppliercardEmailsInfo?.[0]?.emailContactId } })
        setSuppliercardEmailsInfo({})
        addEmailFormValues[index1] = {
          'email': suppliercardEmailsInfo?.[0]?.email,
          'emailType': cardEmailType,
          emailContactId: suppliercardEmailsInfo?.[0]?.emailContactId
        }
        addedEmailFormValues.push({ [index]: { 'email': suppliercardEmailsInfo?.[0]?.email, 'emailType': cardEmailType, emailContactId: suppliercardEmailsInfo?.[0]?.emailContactId } })
        onAddEmails(addEmailFormValues)
        onAddedEmails(addedEmailFormValues)
        onPrimaryCardEmail([])
      }
    } else {
      toast.show({
        title: 'Warning',
        description: 'Please add Email Address',
      })
      return
    }
  };

  const removeEmail = (index) => {
    let data = [...emailValues];
    let addedEmailsData = { ...addEmailValues };
    delete data[index - 1]
    setEmailValues(data)
    delete addedEmailsData[index - 1]
    setAddEmailValues(addedEmailsData)
    onAddEmails(addedEmailsData)
    onAddedEmails(data)
  }

  const handleEmailsChange = (event, index = '') => {
    if (index !== 0) {
      let newFormValues = [...emailValues];
      newFormValues[index - 1][event.target.name] = event.target.value;
      setEmailValues(newFormValues);
      let addEmailFormValues = addEmailValues;
      addEmailFormValues[index - 1] = {
        'email': event.target.value,
        'emailType': cardEmailType
      }
      setAddEmailValues(addEmailFormValues)
      onAddEmails(addEmailFormValues)
    } else {
      setSuppliercardEmailsInfo({ ...suppliercardEmailsInfo, [index]: { email: event.target.value, emailContactId: null } })
      onPrimaryCardEmail(event.target.value)
      var oldValue = event.target.defaultValue
      let addEmailAllValues = { ...addEmailValues };
      if (oldValue === '') {
        addEmailAllValues[Object.keys(addEmailValues).length] = {
          'email': event.target.value,
          'emailType': cardEmailType
        }
      } else {
        var newIndex = Object.keys(addEmailValues).length;
        addEmailAllValues[newIndex] = {
          'email': event.target.value,
          'emailType': cardEmailType
        }
      }
      // onAddEmails(addEmailAllValues)
    }
  }

  const handlePhoneNumberFocusOut = async (event, country, phoneValue, colName) => {
    handleCardPhoneNumberFocusOut(event, country, phoneValue, colName)
  }

  const handleKeyDown = (e, phoneInputRefname) => {
    if (e.keyCode === 9) {
      phoneInputRefname.current.props.onBlur()
    }
  }

  const handleEmailFocusOut = async (emailValue, isRetry = false) => {
    handleCardEmailFocusOut(emailValue, false, isRetry)
  }

  const handleCloseAdvanceAccDetailsModal = () => {
    setShowAdvanceAccDetailsModal(false)
    setDeliveryMethodValues(
      {
        email: false,
        phone: false,
        fax: false,
        online: false,
        pos: false,
      }
    )
  }

  const handleDeliveryMethodsChange = (checked, name) => {
    setDeliveryMethodValues({ ...deliveryMethodValues, [name]: checked })
  }

  const setDeliveryMethodsFeeValues = (feeSettings, selectedOptions) => {
    if (!feeSettings?.['isAcceptAmericanExpress'] && !feeSettings?.['isAcceptVisa'] && !feeSettings?.['isAcceptMasterCard']) {
      toast.show({
        title: 'Warning',
        description: 'Please select atleast one Card Acceptance!',
      })
      return
    }
    var feeInfo = deliveryMethodFeeValues
    selectedOptions.map((option) => {
      feeInfo = {
        ...feeInfo,
        [option]: feeSettings
      }
    })

    onUpdateDeliveryMethodsFeeValues(feeInfo)
    setDeliveryMethodValues(
      {
        email: false,
        phone: false,
        fax: false,
        online: false,
        pos: false,
      }
    )
    onChangeCardInfo('advancedAcceptanceEnabled', { label: `${true}`, value: true })
    // handleCloseAdvanceAccDetailsModal()
  }

  useEffect(() => {
    if (Object.keys(deliveryMethodsFeeValues).length === 0) {
      return
    }
    setDeliveryMethodFeeValues(deliveryMethodsFeeValues)
  }, [deliveryMethodsFeeValues])

  const getRemittanceRequirements = (columnName, supType) => {
    return (
      <Select
        className="col-8 remit-requirements-selector ms-0 ms-sm-auto h4 mb-0 no-zIndex"
        placeholder="Remittance Requirements"
        classNamePrefix='react-select-selector'
        isMulti
        isClearable={false}
        isDisabled={supType === 'child' ? true : false}
        options={
          remit_requirements_options.map((option) => ({
            label: option,
            value: option.toLowerCase().replaceAll(' ', '-')
          }))
        }
        value={supType === 'child' ? childCardInfo?.[columnName] : cardInfo?.[columnName]}
        onChange={(item) => onChangeCardInfo(columnName, item)}
      />
    )
  }

  const onContactMouseHover = (event) => {
    const parentWithClass = event.target.closest('.phone-input-parent')
    if (event.target?.dataset?.contactId) {
      const contact = allContacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId))
      setCurrentContact(contact ? contact : {})
    } else {
      setCurrentContact({})
    }
    if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
      parentWithClass.nextSibling.style.display = 'block'
    } else if (event.target && event.target?.nextSibling && event.target?.nextSibling?.classList?.value?.includes('contact-view')) {
      event.target.nextSibling.style.display = 'block'
    }
  }

  const onContactMouseHoverOut = (event) => {
    const parentWithClass = event.target.closest('.phone-input-parent')
    if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
      parentWithClass.nextSibling.style.display = 'none'
    } else if (event.target && event.target?.nextSibling && event.target?.nextSibling.classList?.value?.includes('contact-view')) {
      event.target.nextSibling.style.display = 'none'
    }
    setCurrentContact({})
  }

  const onPhoneEmailClick = (type1, type2, type3) => {
    setShowAllContacts({ ...showAllContacts, [type1]: !showAllContacts?.[type1], [type2]: false, [type3]: false })
    setExistedContacts(allContacts)
  }

  const onPhoneEmailFocusOutClick = () => {
    setShowAllContacts({ ...showAllContacts, email: false, phone: false, ivrPhone: false })
    setExistedContacts(allContacts)
  }

  useEffect(() => {
    if (showAllContacts?.ivrPhone && cardInfo?.cardPaymentIVRPhone?.value?.trim() && cardInfo?.cardPaymentIVRPhone?.value?.trim()?.length >= 4) {
      setIsLoadingExistingContacts(true)
      const delayDebounceFn = setTimeout(async () => {
        onGetExistingContacts(cardInfo?.cardPaymentIVRPhone?.value?.trim(), 'phone')
      }, 1000)

      return () => clearTimeout(delayDebounceFn)
    } else {
      setIsLoadingExistingContacts(false)
    }
  }, [cardInfo?.cardPaymentIVRPhone?.value])

  useEffect(() => {
    if (showAllContacts?.phone && cardInfo?.cardPaymentByPhoneValue?.value?.trim() && cardInfo?.cardPaymentByPhoneValue?.value?.trim()?.length >= 4) {
      setIsLoadingExistingContacts(true)
      const delayDebounceFn = setTimeout(async () => {
        onGetExistingContacts(cardInfo?.cardPaymentByPhoneValue?.value?.trim(), 'phone')
      }, 1000)

      return () => clearTimeout(delayDebounceFn)
    } else {
      setIsLoadingExistingContacts(false)
    }
  }, [cardInfo?.cardPaymentByPhoneValue?.value])

  useEffect(() => {
    if (showAllContacts?.email && suppliercardEmailsInfo?.[0]?.email?.trim() && suppliercardEmailsInfo?.[0]?.email?.trim()?.length >= 4) {
      setIsLoadingExistingContacts(true)
      const delayDebounceFn = setTimeout(async () => {
        onGetExistingContacts(suppliercardEmailsInfo?.[0]?.email?.trim(), 'email')
      }, 1000)

      return () => clearTimeout(delayDebounceFn)
    } else {
      setIsLoadingExistingContacts(false)
    }
  }, [suppliercardEmailsInfo?.[0]?.email])

  const onGetExistingContacts = (searchValue, type = '') => {
    try {
      setIsLoadingExistingContacts(true)
      dispatch(getExistingContacts({ searchValue, type })).then((res) => {
        if (res?.contacts && res?.contacts?.length > 0) {
          setExistedContacts(res?.contacts)
        } else {
          setExistedContacts([])
        }
        setIsLoadingExistingContacts(false)
      }).catch(() => {
        setExistedContacts([])
        setIsLoadingExistingContacts(false)
      })
    } catch (err) {
      setExistedContacts([])
      setIsLoadingExistingContacts(false)
    }
  }

  const handleContactClick = async (rowData) => {
    var value = {}
    if (showAllContacts?.phone) {
      if (!rowData?.phone) {
        toast.show({
          title: 'Warning',
          description: 'No phone number is assigned to this contact!'
        })
        return
      }
      value.label = rowData?.phone || ''
      value.value = rowData?.phone || ''
      value.phoneContactId = rowData?.id || null
      onChangeCardInfo('cardPaymentByPhoneValue', value)
      await handlePhoneNumberFocusOut(null, null, value.value, 'cardPaymentByPhoneValue')
      setShowAllContacts({ ...showAllContacts, phone: false })
    }
    if (showAllContacts?.ivrPhone) {
      if (!rowData?.phone) {
        toast.show({
          title: 'Warning',
          description: 'No phone number is assigned to this contact!'
        })
        return
      }
      value.label = rowData?.phone || ''
      value.value = rowData?.phone || ''
      value.ivrPhoneContactId = rowData?.id || null
      onChangeCardInfo('cardPaymentIVRPhone', value)
      await handlePhoneNumberFocusOut(null, null, value.value, 'cardPaymentIVRPhone')
      setShowAllContacts({ ...showAllContacts, ivrPhone: false })
    }
    if (showAllContacts?.email) {
      if (!rowData?.email) {
        toast.show({
          title: 'Warning',
          description: 'No email is assigned to this contact!'
        })
        return
      }
      setSuppliercardEmailsInfo({ ...suppliercardEmailsInfo, 0: { email: rowData?.email || '', emailContactId: rowData?.id || null } })
      onPrimaryCardEmail(rowData?.email || '', rowData?.id || null)
      await handleEmailFocusOut(rowData?.email || '')
    }
    if (rowData) {
      const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
      const index = tmpContacts?.findIndex(data => data?.id === rowData?.id)
      if (index === -1) {
        tmpContacts.push(rowData)
      }
      setAllContacts(tmpContacts)
    }
    onPhoneEmailFocusOutClick()
  }

  const onCreateContact = () => {
    let value = ''
    let colName = ''
    let colToUpdate = ''
    if (showAllContacts?.phone) {
      colName = 'phone'
      colToUpdate = 'phone'
      value = cardInfo?.cardPaymentByPhoneValue?.value ? (!/^\s*(?:\+?(\d{1,3})\s)/.test(cardInfo?.cardPaymentByPhoneValue?.value) ? `1 ${cardInfo?.cardPaymentByPhoneValue?.value}` : cardInfo?.cardPaymentByPhoneValue?.value) : ''
    } else if (showAllContacts?.ivrPhone) {
      colName = 'phone'
      colToUpdate = 'ivrPhone'
      value = cardInfo?.cardPaymentIVRPhone?.value ? (!/^\s*(?:\+?(\d{1,3})\s)/.test(cardInfo?.cardPaymentIVRPhone?.value) ? `1 ${cardInfo?.cardPaymentIVRPhone?.value}` : cardInfo?.cardPaymentIVRPhone?.value) : ''
    } else {
      colName = 'email'
      colToUpdate = 'email'
      value = suppliercardEmailsInfo?.[0]?.email || ''
    }

    setShowAddNewContact(true)
    setContactDataFromField({
      colName,
      value,
      colToUpdate
    })
    onPhoneEmailFocusOutClick()
  }


  const handleCreateContactClose = async (e, isGetContactsData = false, contact = null) => {
    const contactId = contact?.id || null
    if (contactId) {
      contact.contactName = contact?.firstname + ' ' + contact?.lastname
      const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
      tmpContacts.push(contact)
      if (contactDataFromField?.colToUpdate === 'phone') {
        var value = {}
        value.value = contact?.phone || ''
        value.phoneContactId = contactId
        onChangeCardInfo('cardPaymentByPhoneValue', value, null)
        await handlePhoneNumberFocusOut(null, null, value.value, 'cardPaymentByPhoneValue')
      } else if (contactDataFromField?.colToUpdate === 'ivrPhone') {
        var value = {}
        value.value = contact?.phone || ''
        value.ivrPhoneContactId = contactId
        onChangeCardInfo('cardPaymentIVRPhone', value)
        await handlePhoneNumberFocusOut(null, null, value.value, 'cardPaymentIVRPhone')
      }  else if (contactDataFromField?.colToUpdate === 'email') {
        setSuppliercardEmailsInfo({
          ...suppliercardEmailsInfo, [0]: {
            email: contact?.email || '',
            emailContactId: contactId || null
          }
        })
        onPrimaryCardEmail(contact?.email || '', contactId || null, true)
      }
      setAllContacts(tmpContacts)
      setExistedContacts(tmpContacts)
    }

    setContactDataFromField({})
    setShowAddNewContact(false)
  }

  const onGetContactsData = () => {
    if (showAllContacts?.phone) {
      onGetExistingContacts(cardInfo?.cardPaymentByPhoneValue?.value?.trim(), 'phone')
    } else if (showAllContacts?.ivrPhone) {
      onGetExistingContacts(cardInfo?.cardPaymentIVRPhone?.value?.trim(), 'phone')
    } else if (showAllContacts?.email) {
      onGetExistingContacts(suppliercardEmailsInfo?.[0]?.email?.trim(), 'email')
    }
  }

  const handleRemoveContact = (colName) => {
    var value = {}
    if (colName === 'email') {
      setSuppliercardEmailsInfo({ ...suppliercardEmailsInfo, 0: { email: '', emailContactId: null } })
      onPrimaryCardEmail('', null)
    } else if (colName === 'phone') {
      value.label = ''
      value.value = ''
      value.phoneContactId = null
      onChangeCardInfo('cardPaymentByPhoneValue', value, 'phone')
    } else if (colName === 'ivrPhone') {
      value.label = ''
      value.value = ''
      value.ivrPhoneContactId = null
      onChangeCardInfo('cardPaymentIVRPhone', value, 'phone')
    }
  }

  return (
    <>
      <div className="card-tab">
        <div className="accept-list">
          {(!showAcceptancePerCard || !showChildAcceptancePerCard) &&
            <>
              <div className='accept-item'>
                <h4 className={`fw-bold toggle-item-text text-black mb-0 ${isFromList ? 'flex-grow-1' : ''}`}>Accepts Credit Cards:
                  <img className='item-image ms-0 ms-sm-3' src={AmexImg} />
                  <img className='item-image ms-0 ms-sm-3' src={VisaImg} />
                  <img className='item-image ms-0 ms-sm-3' src={MasterCardImg} />
                  {!showAcceptancePerCard && (
                    <>
                      <input type="checkbox" className="btn-check" id="btn-check" autoComplete="off" checked={showAcceptancePerCard}
                        onChange={(event) => { onChangeGenericFeeInfo('isAcceptAcceptancePerCard', event.target.checked, [], '', [], 'accPerCard') }}
                      />
                      <label className={`btn btn-success p-3 ${isFromList ? 'ms-0 ms-sm-3' : ''}`} htmlFor="btn-check">{accPerCardText}</label>
                    </>
                  )}
                </h4>
                {!isFromList &&
                  (!showChildAcceptancePerCard ? (
                    <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo?.isAcceptAmericanExpress} isDisabled={true} />
                    </div>
                  ) : <div></div>)}
                {!showAcceptancePerCard ? (
                  <div className='flex justify-end'><ThreeStateToggleButton
                    onChange={(checked) => { onChangeGenericFeeInfo('showCreditCards', checked, ['isAcceptAmericanExpress', 'isAcceptMasterCard', 'isAcceptVisa', 'isAcceptDiscover']) }}
                    checked={genericFeeValues?.showCreditCards} />
                  </div>
                ) : <div></div>}
              </div>
              {
                ((genericFeeValues?.showCreditCards && !showAcceptancePerCard) || (!showChildAcceptancePerCard && childCardData?.isAcceptAmericanExpress)) && !cardInfo?.advancedAcceptanceEnabled?.value && (
                  <div className="accept-item processing-fee">
                    <h4 className='fw-bold text-black mb-0'>Credit Card Conditions:</h4>
                    {!isFromList && (!showChildAcceptancePerCard && childCardData?.isAcceptAmericanExpress ? (
                      <div className='flex processing-fee-parent'>
                        <h4></h4>
                        <div className='d-flex align-items-center'>
                          <h4 className='fw-bold mb-0 text-black'>Amount</h4>
                          <ThreeStateToggleButton customClass='ms-auto' isDisabled={true} checked={childCardInfo?.isAcceptAmexCardConditions?.value} />
                        </div>
                      </div>
                    ) : <div></div>)}
                    {genericFeeValues?.showCreditCards && !showAcceptancePerCard ? (
                      <div className='flex processing-fee-parent align-items-center'>
                        <h4 className={`fw-bold mb-0 text-black${genericFeeValues?.showCardConditions ? '' : ' d-none'}`}>Fee</h4>
                        <div className='d-flex align-items-center'>
                          <h4 className={`fw-bold mb-0 text-black${genericFeeValues?.showCardConditions ? '' : ' d-none'}`}>Amount</h4>
                          <ThreeStateToggleButton customClass='ms-auto' onChange={(checked) => { onChangeGenericFeeInfo('showCardConditions', checked, ['isAcceptAmexCardConditions', 'isAcceptVisaCardConditions', 'isAcceptMastercardCardConditions']) }} checked={genericFeeValues?.showCardConditions} />
                        </div>
                      </div>
                    ) :
                      <div></div>}
                  </div>
                )
              }
              {
                ((genericFeeValues?.showCreditCards && !showAcceptancePerCard && genericFeeValues?.showCardConditions) || (!showChildAcceptancePerCard && childCardData?.isAcceptAmericanExpress && childCardInfo?.isAcceptAmexCardConditions?.value)) && !cardInfo?.advancedAcceptanceEnabled?.value && (
                  <div className="accept-item flex-column">
                    {genericFeeValues?.showCreditCards && !showAcceptancePerCard && genericFeeValues?.showCardConditions &&
                      <div className="row flex justify-space-between align-center g-0">
                        <h4 className="name mb-0">Credit Card Processing Fee</h4>
                        {!isFromList && (
                          <div></div>
                        )}
                        {genericFeeValues?.showCreditCards ?
                          <div className='processing-fee-parent flex'>
                            <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                              <div className='d-flex'>
                                <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                  <Select //flex-sm-grow-0
                                    menuMaxHeight={48}
                                    className="processing-fee-dropdown h4 mb-0"
                                    options={
                                      [
                                        {
                                          label: '$',
                                          value: '$',
                                        },
                                        {
                                          label: '%',
                                          value: '%',
                                        },
                                      ]
                                    }
                                    value={{
                                      label: genericFeeValues?.processingFeeType || '$',
                                      value: genericFeeValues?.processingFeeType || '$'
                                    }}
                                    onChange={(item) => { onChangeGenericFeeInfo('processingFeeType', item?.value, ['amexProcessingFeeType', 'visaProcessingFeeType', 'mastercardProcessingFeeType', 'discoverProcessingFeeType'], 'processingFeeValue', ['amexProcessingFeeValue', 'visaProcessingFeeValue', 'mastercardProcessingFeeValue', 'discoverProcessingFeeValue']) }}
                                  />
                                  <input
                                    className='search-input'
                                    value={genericFeeValues?.processingFeeValue || ''}
                                    onChange={(e) => { onChangeGenericFeeInfo('processingFeeValue', e.target.value, ['amexProcessingFeeValue', 'visaProcessingFeeValue', 'mastercardProcessingFeeValue', 'discoverProcessingFeeValue'], '', [], genericFeeValues?.processingFeeType === '$' ? 'currency' : 'percent') }}
                                    placeholder={genericFeeValues?.processingFeeType === '$' ? '1,234.00' : '12.50'}
                                  />
                                </div>
                                <button className='ms-2 show-option-btn' disabled={(!genericFeeValues?.processingFeeValue || showAnotherProcessingFee) ? true : false}
                                  onClick={() => onChangeGenericFeeInfo('showAnotherProcessingFee', true, [], '', [], 'showHideFee')}
                                > + </button>
                              </div>

                              {showAnotherProcessingFee && (
                                <div className='d-flex'>
                                  <div className='flex processing-fee-dropdown-parent align-center'>
                                    <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                      <Select // flex-sm-grow-0
                                        menuMaxHeight={48}
                                        className="processing-fee-dropdown h4 mb-0"
                                        options={
                                          [
                                            {
                                              label: '$',
                                              value: '$',
                                            },
                                            {
                                              label: '%',
                                              value: '%',
                                            },
                                          ]
                                        }
                                        value={{
                                          label: genericFeeValues?.processingSecondFeeType || '$',
                                          value: genericFeeValues?.processingSecondFeeType || '$'
                                        }}
                                        onChange={(item) => { onChangeGenericFeeInfo('processingSecondFeeType', item?.value, ['amexSecondProcessingFeeType', 'visaSecondProcessingFeeType', 'mastercardSecondProcessingFeeType', 'discoverSecondProcessingFeeType'], 'processingSecondFeeValue', ['amexSecondProcessingFeeValue', 'visaSecondProcessingFeeValue', 'mastercardSecondProcessingFeeValue', 'discoverSecondProcessingFeeValue']) }}
                                      />
                                      <input
                                        className='search-input'
                                        value={genericFeeValues?.processingSecondFeeValue || ''}
                                        onChange={(e) => { onChangeGenericFeeInfo('processingSecondFeeValue', e.target.value, ['amexSecondProcessingFeeValue', 'visaSecondProcessingFeeValue', 'mastercardSecondProcessingFeeValue', 'discoverSecondProcessingFeeValue'], '', [], genericFeeValues?.processingSecondFeeType === '$' ? 'currency' : 'percent') }}
                                        placeholder={genericFeeValues?.processingSecondFeeType === '$' ? '1,234.00' : '12.50'}
                                      />
                                    </div>
                                    <button className='ms-2 hide-option-btn'
                                      onClick={() => onChangeGenericFeeInfo('processingSecondFeeValue', '', ['amexSecondProcessingFeeValue', 'visaSecondProcessingFeeValue', 'mastercardSecondProcessingFeeValue', 'discoverSecondProcessingFeeValue'], '', [], genericFeeValues?.processingSecondFeeType === '$' ? 'currency' : 'percent', 'showAnotherProcessingFee')}
                                    > - </button>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div></div>
                          </div>
                          :
                          <div></div>
                        }
                      </div>
                    }

                    <div className="row g-0 flex-column flex-md-row align-items-center">
                      <h4 className="name mb-0">Credit Card Minimum Payment:</h4>
                      {!isFromList && ((!showChildAcceptancePerCard && childCardData?.isAcceptAmericanExpress && childCardInfo?.isAcceptAmexCardConditions?.value) ? (
                        <div className='processing-fee-parent flex'>
                          <div></div>
                          <div className='flex payment-parent'>
                            <div className="search-input-parent currency">
                              {childCardData?.americanExpressMinPaymnet ?
                                <span>$</span>
                                :
                                ''
                              }
                              <input
                                type="text"
                                className={`search-input ${childCardData?.americanExpressMinPaymnet ? 'has-value' : ''}`}
                                value={childCardData?.americanExpressMinPaymnet || ''}
                                placeholder='$ 1,234.00'
                                disabled={true}
                              />
                            </div>
                            <div></div>
                          </div>
                        </div>
                      ) : <div></div>)}
                      {genericFeeValues?.showCreditCards && !showAcceptancePerCard && genericFeeValues?.showCardConditions ?
                        <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                          {showMinFee ? (
                            <div className='flex processing-fee-dropdown-parent align-center'>
                              <div className='flex processing-fee-dropdown-child'>
                                <Select
                                  className="processing-fee-dropdown h4 mb-0"
                                  options={
                                    [
                                      {
                                        label: '$',
                                        value: '$',
                                      },
                                      {
                                        label: '%',
                                        value: '%',
                                      },
                                    ]
                                  }
                                  value={{
                                    label: genericFeeValues?.minFeeType || '$',
                                    value: genericFeeValues?.minFeeType || '$'
                                  }}
                                  onChange={(item) => { onChangeGenericFeeInfo('minFeeType', item?.value, ['amexMinPaymentFeeType', 'visaMinPaymentFeeType', 'mastercardMinPaymentFeeType', 'discoverMinPaymentFeeType'], 'minFeeValue', ['amexMinPaymentFeeValue', 'visaMinPaymentFeeValue', 'mastercardMinPaymentFeeValue', 'discoverMinPaymentFeeValue']) }}
                                />
                                <input
                                  className='search-input'
                                  value={genericFeeValues?.minFeeValue || ''}
                                  onChange={(e) => { onChangeGenericFeeInfo('minFeeValue', e.target.value, ['amexMinPaymentFeeValue', 'visaMinPaymentFeeValue', 'mastercardMinPaymentFeeValue', 'discoverMinPaymentFeeValue'], '', [], genericFeeValues?.minFeeType === '$' ? 'currency' : 'percent') }}
                                  placeholder={genericFeeValues?.minFeeType === '$' ? '1,234.00' : '12.50'}
                                />
                              </div>
                              <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if under</h4>
                            </div>
                          )
                            : <div></div>}
                          <div className='flex payment-parent'>
                            <div className="search-input-parent currency">
                              {genericFeeValues?.minPayment ?
                                <span>$</span>
                                :
                                ''
                              }
                              <input
                                type="text"
                                className={`search-input ${genericFeeValues?.minPayment ? 'has-value' : ''}`}
                                value={genericFeeValues?.minPayment || ''}
                                onChange={(e) => { onChangeGenericFeeInfo('minPayment', e.target.value, ['americanExpressMinPaymnet', 'visaMinPayment', 'mastercardMinPayment', 'discoverMinPayment'], '', [], 'currency') }}
                                placeholder='$ 1,234.00'
                              />
                            </div>
                            {showMinFee ?
                              <button className='hide-option'
                                onClick={() => onChangeGenericFeeInfo('showMinFee', false, [], '', [], 'showHideFee')}
                              > - </button>
                              :
                              <button className='show-option'
                                onClick={() => onChangeGenericFeeInfo('showMinFee', true, [], '', [], 'showHideFee')}
                              > + </button>
                            }
                          </div>
                        </div>
                        :
                        <div></div>
                      }
                    </div>
                    <div className="row g-0 flex-column flex-md-row align-items-center">
                      <h4 className="name mb-0">Credit Card Maximum Payment:</h4>
                      {!isFromList && ((!showChildAcceptancePerCard && childCardData?.isAcceptAmericanExpress && childCardInfo?.isAcceptAmexCardConditions?.value) ? (
                        <div className='processing-fee-parent flex'>
                          <div></div>
                          <div className='flex payment-parent'>
                            <div className="search-input-parent currency">
                              {childCardData?.americanExpressMaxPayment ?
                                <span>$</span>
                                :
                                ''
                              }
                              <input
                                type="text"
                                className={`search-input ${childCardData?.americanExpressMaxPayment ? 'has-value' : ''}`}
                                value={childCardData?.americanExpressMaxPayment || ''}
                                placeholder='$ 1,234.00'
                                disabled={true}
                              />
                            </div>
                            <div></div>
                          </div>
                        </div>
                      ) : <div></div>)}
                      {genericFeeValues?.showCreditCards && !showAcceptancePerCard && genericFeeValues?.showCardConditions ?
                        <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                          {showMaxFee ? (
                            <div className='flex processing-fee-dropdown-parent align-center'>
                              <div className='flex processing-fee-dropdown-child'>
                                <Select
                                  className="processing-fee-dropdown h4 mb-0"
                                  options={
                                    [
                                      {
                                        label: '$',
                                        value: '$',
                                      },
                                      {
                                        label: '%',
                                        value: '%',
                                      },
                                    ]
                                  }
                                  value={{
                                    label: genericFeeValues?.maxFeeType || '$',
                                    value: genericFeeValues?.maxFeeType || '$'
                                  }}
                                  onChange={(item) => { onChangeGenericFeeInfo('maxFeeType', item?.value, ['amexMaxPaymentFeeType', 'visaMaxPaymentFeeType', 'mastercardMaxPaymentFeeType', 'discoverMaxPaymentFeeType'], 'maxFeeValue', ['amexMaxPaymentFeeValue', 'visaMaxPaymentFeeValue', 'mastercardMaxPaymentFeeValue', 'discoverMaxPaymentFeeValue']) }}
                                />
                                <input
                                  className='search-input'
                                  value={genericFeeValues?.maxFeeValue || ''}
                                  onChange={(e) => { onChangeGenericFeeInfo('maxFeeValue', e.target.value, ['amexMaxPaymentFeeValue', 'visaMaxPaymentFeeValue', 'mastercardMaxPaymentFeeValue', 'discoverMaxPaymentFeeValue'], '', [], genericFeeValues?.maxFeeType === '$' ? 'currency' : 'percent') }}
                                  placeholder={genericFeeValues?.maxFeeType === '$' ? '1,234.00' : '12.50'}
                                />
                              </div>
                              <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee if over</h4>
                            </div>
                          )
                            : <div></div>}
                          <div className='flex payment-parent'>
                            <div className="search-input-parent currency">
                              {genericFeeValues?.maxPayment ?
                                <span>$</span>
                                :
                                ''
                              }
                              <input
                                type="text"
                                className={`search-input ${genericFeeValues?.maxPayment ? 'has-value' : ''}`}
                                value={genericFeeValues?.maxPayment || ''}
                                onChange={(e) => { onChangeGenericFeeInfo('maxPayment', e.target.value, ['americanExpressMaxPayment', 'visaMaxPayment', 'mastercardMaxPayment', 'discoverMaxPayment'], '', [], 'currency') }}
                                placeholder='$ 1,234.00'
                              />
                            </div>
                            {showMaxFee ?
                              <button className='hide-option'
                                onClick={() => onChangeGenericFeeInfo('showMaxFee', false, [], '', [], 'showHideFee')}
                              > - </button>
                              :
                              <button className='show-option'
                                onClick={() => onChangeGenericFeeInfo('showMaxFee', true, [], '', [], 'showHideFee')}
                              > + </button>
                            }
                          </div>
                        </div>
                        :
                        <div></div>
                      }
                    </div>
                    <div className="row g-0 flex-column flex-md-row align-items-center">
                      <h4 className="name mb-0">Incremental Fee:</h4>
                      {!isFromList && ((!showChildAcceptancePerCard && childCardData?.isAcceptAmericanExpress && childCardInfo?.isAcceptAmexCardConditions?.value) ? (
                        <div className='processing-fee-parent flex'>
                          <div></div>
                          <div className='flex payment-parent'>
                            <div className="search-input-parent currency">
                              {childCardData?.amexIncrementalPaymentAmount ?
                                <span>$</span>
                                :
                                ''
                              }
                              <input
                                type="text"
                                className={`search-input ${childCardData?.amexIncrementalPaymentAmount ? 'has-value' : ''}`}
                                value={childCardData?.amexIncrementalPaymentAmount || ''}
                                placeholder='$ 1,234.00'
                                disabled={true}
                              />
                            </div>
                            <div></div>
                          </div>
                        </div>
                      ) : <div></div>)}
                      {genericFeeValues?.showCreditCards && !showAcceptancePerCard && genericFeeValues?.showCardConditions ?
                        <div className='processing-fee-parent gap-3 gap-sm-0 d-flex flex-column flex-sm-row'>
                          {showIncrementalFee ? (
                            <div className='flex processing-fee-dropdown-parent align-center'>
                              <div className='flex processing-fee-dropdown-child'>
                                <Select
                                  className="processing-fee-dropdown h4 mb-0"
                                  options={
                                    [
                                      {
                                        label: '$',
                                        value: '$',
                                      },
                                      {
                                        label: '%',
                                        value: '%',
                                      },
                                    ]
                                  }
                                  value={{
                                    label: genericFeeValues?.incrementalFeeType || '$',
                                    value: genericFeeValues?.incrementalFeeType || '$'
                                  }}
                                  onChange={(item) => { onChangeGenericFeeInfo('incrementalFeeType', item?.value, ['amexIncrementalFeeType', 'visaIncrementalFeeType', 'mastercardIncrementalFeeType', 'discoverIncrementalFeeType'], 'incrementalFeeValue', ['amexIncrementalFeeValue', 'visaIncrementalFeeValue', 'mastercardIncrementalFeeValue', 'discoverIncrementalFeeValue']) }}
                                />
                                <input
                                  className='search-input'
                                  value={genericFeeValues?.incrementalFeeValue || ''}
                                  onChange={(e) => { onChangeGenericFeeInfo('incrementalFeeValue', e.target.value, ['amexIncrementalFeeValue', 'visaIncrementalFeeValue', 'mastercardIncrementalFeeValue', 'discoverIncrementalFeeValue'], '', [], genericFeeValues?.incrementalFeeType === '$' ? 'currency' : 'percent') }}
                                  placeholder={genericFeeValues?.incrementalFeeType === '$' ? '1,234.00' : '12.50'}
                                />
                              </div>
                              <h4 className='flex-grow-1 text-center mb-0 text-black'>Fee for every</h4>
                            </div>
                          )
                            : <div></div>}
                          <div className='flex payment-parent'>
                            {showIncrementalFee ? (
                              <div className="search-input-parent currency">
                                {genericFeeValues?.incrementalPayment ?
                                  <span>$</span>
                                  :
                                  ''
                                }
                                <input
                                  type="text"
                                  className={`search-input ${genericFeeValues?.incrementalPayment ? 'has-value' : ''}`}
                                  value={genericFeeValues?.incrementalPayment || ''}
                                  onChange={(e) => { onChangeGenericFeeInfo('incrementalPayment', e.target.value, ['amexIncrementalPaymentAmount', 'visaIncrementalPaymentAmount', 'mastercardIncrementalPaymentAmount', 'discoverIncrementalPaymentAmount'], '', [], 'currency') }}
                                  placeholder='$ 1,234.00'
                                />
                              </div>
                            )
                              : <div></div>}
                            {showIncrementalFee ?
                              <button className='hide-option'
                                onClick={() => onChangeGenericFeeInfo('showIncrementalFee', false, [], '', [], 'showHideFee')}
                              > - </button>
                              :
                              <button className='show-option'
                                onClick={() => onChangeGenericFeeInfo('showIncrementalFee', true, [], '', [], 'showHideFee')}
                              > + </button>
                            }
                          </div>
                        </div>
                        :
                        <div></div>
                      }
                    </div>
                    <div className="accept-item">
                      <h4 className='fw-bold toggle-item-text text-black mb-0'>Variable Fee:</h4>
                      {!isFromList &&
                        ((!showChildAcceptancePerCard && childCardData?.isAcceptAmericanExpress && childCardInfo?.isAcceptAmexCardConditions?.value) ? (
                          <div className='flex justify-end'><ThreeStateToggleButton checked={childCardData?.isAcceptAmexVariableFee} isDisabled={true} />
                          </div>
                        ) : <div></div>)}
                      {!showAcceptancePerCard && genericFeeValues?.showCreditCards && genericFeeValues?.showCardConditions ? (
                        <div className='flex justify-end'><ThreeStateToggleButton
                          onChange={(checked) => { onChangeGenericFeeInfo('showVariableFee', checked, ['isAcceptAmexVariableFee', 'isAcceptVisaVariableFee', 'isAcceptMasterCardVariableFee']) }}
                          checked={genericFeeValues?.showVariableFee} />
                        </div>
                      ) : <div></div>}
                    </div>
                  </div>
                )
              }
            </>
          }

          {showAcceptancePerCard && (
            <div className="item">
              <input type="checkbox" className="btn-check" id="btn-check" autoComplete="off" checked={showAcceptancePerCard}
                onChange={(event) => { onChangeGenericFeeInfo('isAcceptAcceptancePerCard', event.target.checked, [], '', [], 'accPerCard') }} />
              <label className="btn btn-success p-3" htmlFor="btn-check">{accPerCardText}</label>
            </div>
          )}

          {(showAcceptancePerCard || showChildAcceptancePerCard) &&
            <>
              <div className="accept-item">
                <h4 className='fw-bold toggle-item-text text-black mb-0'>Accepts Amex: <img className='item-image' src={AmexImg} /></h4>
                {!isFromList && (showChildAcceptancePerCard ?
                  <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo[columns[0].name].value} isDisabled={true} /></div>
                  : <div></div>)}
                {showAcceptancePerCard ? (
                  <>
                    <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo[columns[0].name]?.value} onChange={(checked) => onChangeCardInfo(columns[0].name, { label: `${checked}`, value: checked })} /></div>
                  </>
                ) : <div></div>}
              </div>
              {
                ((showAmex && showAcceptancePerCard) || (showChildAmex && showChildAcceptancePerCard)) && !cardInfo[columns[48].name]?.value && (
                  <div className="accept-item">
                    <h4 className='fw-bold text-black mb-0'>Amex Conditions:</h4>
                    {!isFromList && ((showChildAmex && showChildAcceptancePerCard) ? (
                      <div className='flex processing-fee-parent align-items-center'>
                        <h4></h4>
                        <div className='d-flex align-items-center'>
                          <h4 className='fw-bold mb-0 text-black'>Amount</h4>
                          <ThreeStateToggleButton customClass='ms-auto' isDisabled={true} checked={childCardInfo?.isAcceptAmexCardConditions?.value} />
                        </div>
                      </div>
                    ) :
                      <div></div>)}
                    {showAmex && showAcceptancePerCard ? (
                      <div className='flex processing-fee-parent align-items-center'>
                        <h4 className={`fw-bold mb-0 text-black${cardInfo?.isAcceptAmexCardConditions?.value ? '' : ' d-none'}`}>Fee</h4>
                        <div className='d-flex align-items-center'>
                          <h4 className={`fw-bold mb-0 text-black${cardInfo?.isAcceptAmexCardConditions?.value ? '' : ' d-none'}`}>Amount</h4>
                          <ThreeStateToggleButton customClass='ms-auto' onChange={(checked) => onCardConditionsChange('isAcceptAmexCardConditions', { label: `${checked}`, value: checked })} checked={cardInfo?.isAcceptAmexCardConditions?.value} />
                        </div>
                      </div>
                    ) :
                      <div></div>}
                  </div>
                )
              }
              {
                ((showAmex && showAcceptancePerCard) || (showChildAmex && showChildAcceptancePerCard)) && !cardInfo[columns[48].name]?.value && (
                  <div className="accept-item flex-column">
                    {showAcceptancePerCard && (
                      showAmex && cardInfo?.isAcceptAmexCardConditions?.value && (
                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Amex Processing Fee</span>
                          {!isFromList && (
                            <div></div>
                          )}
                          {showAmex ? (
                            <div className='processing-fee-parent flex'>
                              <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                                <div className='d-flex'>
                                  <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[49].name]?.value || '$',
                                        value: cardInfo[columns[49].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('amexProcessingFeeType', item, 'feeValue', 'amexProcessingFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[50].name].value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[50].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[49].name]?.value || cardInfo[columns[49].name]?.value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[49].name]?.value || cardInfo[columns[49].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <button className='ms-2 show-option-btn' disabled={(!cardInfo?.amexProcessingFeeValue?.value || showAmexSecondProcessingFee) ? true : false} onClick={() => { handleUpdateCardFeeInfo('showAmexSecondProcessingFee', true) }}> + </button>
                                </div>

                                {showAmexSecondProcessingFee && (
                                  <div className='d-flex'>
                                    <div className='flex processing-fee-dropdown-parent align-center'>
                                      <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                        <Select // flex-sm-grow-0
                                          menuMaxHeight={48}
                                          className="processing-fee-dropdown h4 mb-0"
                                          options={
                                            [
                                              {
                                                label: '$',
                                                value: '$',
                                              },
                                              {
                                                label: '%',
                                                value: '%',
                                              },
                                            ]
                                          }
                                          value={{
                                            label: cardInfo?.amexSecondProcessingFeeType?.value || '$',
                                            value: cardInfo?.amexSecondProcessingFeeType?.value || '$'
                                          }}
                                          onChange={(item) => { handleUpdateCardFeeInfo('amexSecondProcessingFeeType', item, 'feeValue', 'amexSecondProcessingFeeValue') }}
                                        />
                                        <input
                                          className='search-input'
                                          value={cardInfo?.amexSecondProcessingFeeValue?.value || ''}
                                          onChange={(e) => onChangeCardInfo('amexSecondProcessingFeeValue', { label: e.target.value, value: e.target.value }, (!cardInfo?.amexSecondProcessingFeeType?.value || cardInfo.amexSecondProcessingFeeType?.value === '$') ? 'currency' : 'percent')}
                                          placeholder={(!cardInfo?.amexSecondProcessingFeeType?.value || cardInfo?.amexSecondProcessingFeeType?.value === '$') ? '1,234.00' : '12.50'}
                                        />
                                      </div>
                                      <button className='ms-2 hide-option-btn'
                                        onClick={() => {
                                          handleUpdateCardFeeInfo('showAmexSecondProcessingFee', false);
                                          onChangeCardInfo('amexSecondProcessingFeeValue', { label: '', value: '' }, cardInfo.amexSecondProcessingFeeType?.value === '$' ? 'currency' : 'percent')
                                        }}
                                      > - </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div></div>
                            </div>
                          ) : <div></div>}
                        </div>
                      )
                    )}

                    {(cardInfo?.isAcceptAmexCardConditions?.value || childCardInfo?.isAcceptAmexCardConditions?.value) && (
                      <>
                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Amex Minimum Payment:</span>
                          {!isFromList && ((showChildAmex && showChildAcceptancePerCard && childCardInfo?.isAcceptAmexCardConditions?.value) ? (
                            <div className='processing-fee-parent flex'>
                              <div></div>
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {childCardInfo[columns[8]?.name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${childCardInfo[columns[8]?.name]?.value ? 'has-value' : ''}`}
                                    value={childCardInfo[columns[8]?.name]?.value || ''}
                                    placeholder='$ 1,234.00'
                                    disabled={true}
                                  />
                                </div>
                                <div></div>
                              </div>
                            </div>
                          ) : <div></div>)}
                          {showAmex && showAcceptancePerCard && cardInfo?.isAcceptAmexCardConditions?.value ? (
                            <div className='processing-fee-parent flex'>
                              {showAmexMinFee ? (
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[51].name]?.value || '$',
                                        value: cardInfo[columns[51].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('amexMinPaymentFeeType', item, 'feeValue', 'amexMinPaymentFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[52].name].value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[52].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[51].name]?.value || cardInfo[columns[51].name]?.value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[51].name]?.value || cardInfo[columns[51].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <span>Fee if under</span>
                                </div>
                              )
                                : <div></div>}

                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {cardInfo[columns[8].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${cardInfo[columns[8].name].value ? 'has-value' : ''}`}
                                    value={cardInfo[columns[8].name].value || ''}
                                    onChange={(e) => onChangeCardInfo(columns[8].name, { label: e.target.value, value: e.target.value }, 'currency')}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                {showAmexMinFee ?
                                  <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showAmexMinFee', false) }}> - </button>
                                  :
                                  <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showAmexMinFee', true) }}> + </button>
                                }
                              </div>
                            </div>
                          ) : <div></div>}
                        </div>

                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Amex Maximum Payment:</span>
                          {!isFromList && (showChildAmex && showChildAcceptancePerCard && childCardInfo?.isAcceptAmexCardConditions?.value ? (
                            <div className='processing-fee-parent flex'>
                              <div></div>
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {childCardInfo[columns[9].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${childCardInfo[columns[9].name]?.value ? 'has-value' : ''}`}
                                    value={childCardInfo[columns[9].name]?.value || ''}
                                    disabled={true}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                <div></div>
                              </div>
                            </div>
                          ) : <div></div>)}
                          {showAmex && showAcceptancePerCard && cardInfo?.isAcceptAmexCardConditions?.value ? (
                            <div className='processing-fee-parent flex'>
                              {showAmexMaxFee ? (
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[53]?.name]?.value || '$',
                                        value: cardInfo[columns[53]?.name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('amexMaxPaymentFeeType', item, 'feeValue', 'amexMaxPaymentFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[54]?.name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[54]?.name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[53]?.name]?.value || cardInfo[columns[53]?.name]?.value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[53]?.name]?.value || cardInfo[columns[53]?.name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <span>Fee if over</span>
                                </div>
                              )
                                : <div></div>}
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {cardInfo[columns[9]?.name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${cardInfo[columns[9]?.name]?.value ? 'has-value' : ''}`}
                                    value={cardInfo[columns[9]?.name]?.value || ''}
                                    onChange={(e) => onChangeCardInfo(columns[9]?.name, { label: e.target.value, value: e.target.value }, 'currency')}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                {showAmexMaxFee ?
                                  <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showAmexMaxFee', false) }}> - </button>
                                  :
                                  <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showAmexMaxFee', true) }}> + </button>
                                }
                              </div>
                            </div>
                          ) : <div></div>}
                        </div>

                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Incremental Fee:</span>
                          {!isFromList && (showChildAmex && showChildAcceptancePerCard && childCardInfo?.isAcceptAmexCardConditions?.value ? (
                            <div className='processing-fee-parent flex'>
                              <div></div>
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {childCardInfo[columns[57].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${childCardInfo[columns[57].name]?.value ? 'has-value' : ''}`}
                                    value={childCardInfo[columns[57].name]?.value || ''}
                                    disabled={true}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                <div></div>
                              </div>
                            </div>
                          ) : <div></div>)}
                          {showAmex && showAcceptancePerCard && cardInfo?.isAcceptAmexCardConditions?.value ? (
                            <div className='processing-fee-parent flex'>
                              {showAmexIncrementalFee ? (
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                      className="processing-fee-dropdown"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[55].name]?.value || '$',
                                        value: cardInfo[columns[55].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('amexIncrementalFeeType', item, 'feeValue', 'amexIncrementalFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[56].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[56].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[55].name]?.value || cardInfo[columns[55].name].value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[55].name]?.value || cardInfo[columns[55].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <span>Fee for every</span>
                                </div>
                              )
                                : <div></div>}
                              <div className='flex payment-parent'>
                                {showAmexIncrementalFee ? (
                                  <div className="search-input-parent currency">
                                    {cardInfo[columns[57].name]?.value ?
                                      <span>$</span>
                                      :
                                      ''
                                    }
                                    <input
                                      type="text"
                                      className={`search-input ${cardInfo[columns[57].name]?.value ? 'has-value' : ''}`}
                                      value={cardInfo[columns[57].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[57].name, { label: e.target.value, value: e.target.value }, 'currency')}
                                      placeholder='$ 1,234.00'
                                    />
                                  </div>
                                )
                                  : <div></div>}
                                {showAmexIncrementalFee ?
                                  <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showAmexIncrementalFee', false) }}> - </button>
                                  :
                                  <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showAmexIncrementalFee', true) }}> + </button>
                                }
                              </div>
                            </div>
                          ) : <div></div>}
                        </div>

                        <div className="accept-item">
                          <h4 className='fw-bold toggle-item-text text-black mb-0'>Variable Fee:</h4>
                          {!isFromList && (showChildAmex && showChildAcceptancePerCard && childCardInfo?.isAcceptAmexCardConditions?.value ?
                            <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo['isAcceptAmexVariableFee']?.value} isDisabled={true} /></div>
                            : <div></div>)}
                          {showAmex && showAcceptancePerCard && cardInfo?.isAcceptAmexCardConditions?.value ? (
                            <>
                              <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo['isAcceptAmexVariableFee']?.value} onChange={(checked) => onChangeCardInfo('isAcceptAmexVariableFee', { label: `${checked}`, value: checked })} /></div>
                            </>
                          ) : <div></div>}
                        </div>
                      </>
                    )}
                  </div>
                )
              }
              <div className="accept-item">
                <h4 className='fw-bold toggle-item-text text-black mb-0'>Accepts Visa: <img className='item-image' src={VisaImg} /></h4>
                {!isFromList && (showChildAcceptancePerCard ?
                  <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo[columns[1].name]?.value} isDisabled={true} /></div>
                  : <div></div>)}
                {showAcceptancePerCard ? (
                  <>
                    <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo[columns[1].name]?.value} onChange={(checked) => onChangeCardInfo(columns[1].name, { label: `${checked}`, value: checked })} /></div>
                  </>
                ) :
                  <div></div>
                }

              </div>
              {
                ((showVisa && showAcceptancePerCard) || (showChildVisa && showChildAcceptancePerCard)) && !cardInfo[columns[48].name]?.value && (
                  <div className="accept-item">
                    <h4 className='fw-bold text-black mb-0'>Visa Conditions:</h4>
                    {!isFromList && (showChildVisa && showChildAcceptancePerCard ? (
                      <div className='flex processing-fee-parent'>
                        <h4></h4>
                        <div className='d-flex align-items-center'>
                          <h4 className='fw-bold mb-0 text-black'>Amount</h4>
                          <ThreeStateToggleButton customClass='ms-auto' isDisabled={true} checked={childCardInfo?.isAcceptVisaCardConditions?.value} />
                        </div>
                      </div>
                    ) :
                      <div></div>)}
                    {showVisa && showAcceptancePerCard ? (
                      <div className='flex processing-fee-parent align-items-center'>
                        <h4 className={`fw-bold mb-0 text-black${cardInfo?.isAcceptVisaCardConditions?.value ? '' : ' d-none'}`}>Fee</h4>
                        <div className='d-flex align-items-center'>
                          <h4 className={`fw-bold mb-0 text-black${cardInfo?.isAcceptVisaCardConditions?.value ? '' : ' d-none'}`}>Amount</h4>
                          <ThreeStateToggleButton customClass='ms-auto' onChange={(checked) => onCardConditionsChange('isAcceptVisaCardConditions', { label: `${checked}`, value: checked })} checked={cardInfo?.isAcceptVisaCardConditions?.value} />
                        </div>
                      </div>
                    ) :
                      <div></div>}
                  </div>
                )
              }

              {
                ((showVisa && showAcceptancePerCard) || (showChildVisa && showChildAcceptancePerCard)) && !cardInfo[columns[48].name]?.value && (
                  <div className="accept-item flex-column">
                    {showAcceptancePerCard && (
                      showVisa && cardInfo?.isAcceptVisaCardConditions?.value && (
                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Visa Processing Fee</span>
                          {!isFromList && (
                            <div></div>
                          )}
                          {showVisa ? (
                            <div className='processing-fee-parent flex'>
                              <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                                <div className='d-flex'>
                                  <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[58].name]?.value || '$',
                                        value: cardInfo[columns[58].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('visaProcessingFeeType', item, 'feeValue', 'visaProcessingFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[59].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[59].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[58].name]?.value || cardInfo[columns[58].name].value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[58].name]?.value || cardInfo[columns[58].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <button className='ms-2 show-option-btn' disabled={(!cardInfo?.visaProcessingFeeValue?.value || showVisaSecondProcessingFee) ? true : false} onClick={() => { handleUpdateCardFeeInfo('showVisaSecondProcessingFee', true) }}> + </button>
                                </div>

                                {showVisaSecondProcessingFee && (
                                  <div className='d-flex'>
                                    <div className='flex processing-fee-dropdown-parent align-center'>
                                      <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                        <Select // flex-sm-grow-0
                                          menuMaxHeight={48}
                                          className="processing-fee-dropdown h4 mb-0"
                                          options={
                                            [
                                              {
                                                label: '$',
                                                value: '$',
                                              },
                                              {
                                                label: '%',
                                                value: '%',
                                              },
                                            ]
                                          }
                                          value={{
                                            label: cardInfo?.visaSecondProcessingFeeType?.value || '$',
                                            value: cardInfo?.visaSecondProcessingFeeType?.value || '$'
                                          }}
                                          onChange={(item) => { handleUpdateCardFeeInfo('visaSecondProcessingFeeType', item, 'feeValue', 'visaSecondProcessingFeeValue') }}
                                        />
                                        <input
                                          className='search-input'
                                          value={cardInfo?.visaSecondProcessingFeeValue?.value || ''}
                                          onChange={(e) => onChangeCardInfo('visaSecondProcessingFeeValue', { label: e.target.value, value: e.target.value }, (!cardInfo?.visaSecondProcessingFeeType?.value || cardInfo.visaSecondProcessingFeeType?.value === '$') ? 'currency' : 'percent')}
                                          placeholder={(!cardInfo?.visaSecondProcessingFeeType?.value || cardInfo?.visaSecondProcessingFeeType?.value === '$') ? '1,234.00' : '12.50'}
                                        />
                                      </div>
                                      <button className='ms-2 hide-option-btn'
                                        onClick={() => {
                                          handleUpdateCardFeeInfo('showVisaSecondProcessingFee', false);
                                          onChangeCardInfo('visaSecondProcessingFeeValue', { label: '', value: '' }, cardInfo.visaSecondProcessingFeeType?.value === '$' ? 'currency' : 'percent')
                                        }}
                                      > - </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div></div>
                            </div>
                          ) : <div></div>}
                        </div>
                      )
                    )}

                    {(cardInfo?.isAcceptVisaCardConditions?.value || childCardInfo?.isAcceptVisaCardConditions?.value) && (
                      <>
                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Visa Minimum Payment:</span>
                          {!isFromList && (showChildVisa && showChildAcceptancePerCard && childCardInfo?.isAcceptVisaCardConditions?.value ?
                            <div className='processing-fee-parent flex'>
                              <div></div>
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {childCardInfo[columns[13].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${childCardInfo[columns[13].name]?.value ? 'has-value' : ''}`}
                                    value={childCardInfo[columns[13].name]?.value || ''}
                                    disabled={true}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                <div></div>
                              </div>
                            </div>
                            : <div></div>
                          )}
                          {showVisa && showAcceptancePerCard && cardInfo?.isAcceptVisaCardConditions?.value ?
                            <div className='processing-fee-parent flex'>
                              {showVisaMinFee ? (
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[60].name]?.value || '$',
                                        value: cardInfo[columns[60].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('visaMinPaymentFeeType', item, 'feeValue', 'visaMinPaymentFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[61].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[61].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[60].name]?.value || cardInfo[columns[60].name]?.value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[60].name]?.value || cardInfo[columns[60].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <span>Fee if under</span>
                                </div>
                              )
                                : <div></div>}
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {cardInfo[columns[13].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${cardInfo[columns[13].name]?.value ? 'has-value' : ''}`}
                                    value={cardInfo[columns[13].name]?.value || ''}
                                    onChange={(e) => onChangeCardInfo(columns[13].name, { label: e.target.value, value: e.target.value }, 'currency')}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                {showVisaMinFee ?
                                  <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showVisaMinFee', false) }}> - </button>
                                  :
                                  <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showVisaMinFee', true) }}> + </button>
                                }
                              </div>
                            </div>
                            : <div></div>
                          }
                        </div>

                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Visa Maximum Payment:</span>
                          {!isFromList && (showChildVisa && showChildAcceptancePerCard && childCardInfo?.isAcceptVisaCardConditions?.value ?
                            <div className='processing-fee-parent flex'>
                              <div></div>
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {childCardInfo[columns[14].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${childCardInfo[columns[14].name]?.value ? 'has-value' : ''}`}
                                    value={childCardInfo[columns[14].name]?.value || ''}
                                    disabled={true}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                <div></div>
                              </div>
                            </div>
                            : <div></div>
                          )}
                          {showVisa && showAcceptancePerCard && cardInfo?.isAcceptVisaCardConditions?.value ?
                            <div className='processing-fee-parent flex'>
                              {showVisaMaxFee ? (
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[62].name]?.value || '$',
                                        value: cardInfo[columns[62].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('visaMaxPaymentFeeType', item, 'feeValue', 'visaMaxPaymentFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[63].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[63].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[62].name]?.value || cardInfo[columns[62].name].value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[62].name]?.value || cardInfo[columns[62].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <span>Fee if over</span>
                                </div>
                              )
                                : <div></div>}
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {cardInfo[columns[14].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${cardInfo[columns[14].name]?.value ? 'has-value' : ''}`}
                                    value={cardInfo[columns[14].name]?.value || ''}
                                    onChange={(e) => onChangeCardInfo(columns[14].name, { label: e.target.value, value: e.target.value }, 'currency')}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                {showVisaMaxFee ?
                                  <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showVisaMaxFee', false) }}> - </button>
                                  :
                                  <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showVisaMaxFee', true) }}> + </button>
                                }
                              </div>
                            </div>
                            : <div></div>
                          }
                        </div>

                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Incremental Fee:</span>
                          {!isFromList && (showChildVisa && showChildAcceptancePerCard && childCardInfo?.isAcceptVisaCardConditions?.value ? (
                            <div className='processing-fee-parent flex'>
                              <div></div>
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {childCardInfo[columns[66].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${childCardInfo[columns[66].name]?.value ? 'has-value' : ''}`}
                                    value={childCardInfo[columns[66].name]?.value || ''}
                                    disabled={true}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                <div></div>
                              </div>
                            </div>
                          ) : <div></div>)}
                          {showVisa && showAcceptancePerCard && cardInfo?.isAcceptVisaCardConditions?.value ? (
                            <div className='processing-fee-parent flex'>
                              {showVisaIncrementalFee ? (
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[64].name]?.value || '$',
                                        value: cardInfo[columns[64].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('visaIncrementalFeeType', item, 'feeValue', 'visaIncrementalFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[65].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[65].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[64].name]?.value || cardInfo[columns[64].name]?.value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[64].name]?.value || cardInfo[columns[64].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <span>Fee for every</span>
                                </div>
                              )
                                : <div></div>}
                              <div className='flex payment-parent'>
                                {showVisaIncrementalFee ? (
                                  <div className="search-input-parent currency">
                                    {cardFeeInfo?.feeValues?.visaIncrementalPayment ?
                                      <span>$</span>
                                      :
                                      ''
                                    }
                                    <input
                                      type="text"
                                      className={`search-input ${cardFeeInfo?.feeValues?.visaIncrementalPayment ? 'has-value' : ''}`}
                                      value={cardInfo[columns[66].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[66].name, { label: e.target.value, value: e.target.value }, 'currency')}
                                      placeholder='$ 1,234.00'
                                    />
                                  </div>
                                )
                                  : <div></div>}
                                {showVisaIncrementalFee ?
                                  <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showVisaIncrementalFee', false) }}> - </button>
                                  :
                                  <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showVisaIncrementalFee', true) }}> + </button>
                                }
                              </div>
                            </div>
                          ) : <div></div>}
                        </div>

                        <div className="accept-item">
                          <h4 className='fw-bold toggle-item-text text-black mb-0'>Variable Fee:</h4>
                          {!isFromList && (showChildVisa && showChildAcceptancePerCard && childCardInfo?.isAcceptVisaCardConditions?.value ?
                            <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo['isAcceptVisaVariableFee']?.value} isDisabled={true} /></div>
                            : <div></div>)}
                          {showVisa && showAcceptancePerCard && cardInfo?.isAcceptVisaCardConditions?.value ? (
                            <>
                              <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo['isAcceptVisaVariableFee']?.value} onChange={(checked) => onChangeCardInfo('isAcceptVisaVariableFee', { label: `${checked}`, value: checked })} /></div>
                            </>
                          ) : <div></div>}
                        </div>
                      </>
                    )}
                  </div>
                )
              }

              <div className="accept-item">
                <h4 className='fw-bold toggle-item-text text-black mb-0'>Accepts Mastercard: <img className='item-image' src={MasterCardImg} /></h4>
                {!isFromList && (showChildAcceptancePerCard ?
                  <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo[columns[2].name]?.value} isDisabled={true} /></div>
                  : <div></div>)}
                {showAcceptancePerCard ? (
                  <>
                    <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo[columns[2].name]?.value} onChange={(checked) => onChangeCardInfo(columns[2].name, { label: `${checked}`, value: checked })} /></div>
                  </>
                ) :
                  <div></div>
                }
              </div>
              {
                ((showMaster && showAcceptancePerCard) || (showChildMaster && showChildAcceptancePerCard)) && !cardInfo[columns[48].name]?.value && (
                  <div className="accept-item">
                    <h4 className='fw-bold text-black mb-0'>Mastercard Conditions:</h4>
                    {!isFromList && (showChildMaster && showChildAcceptancePerCard ? (
                      <div className='flex processing-fee-parent'>
                        <h4></h4>
                        <div className='d-flex align-items-center'>
                          <h4 className='fw-bold mb-0 text-black'>Amount</h4>
                          <ThreeStateToggleButton customClass='ms-auto' isDisabled={true} checked={childCardInfo?.isAcceptMastercardCardConditions?.value} />
                        </div>
                      </div>
                    ) :
                      <div></div>)}
                    {showMaster && showAcceptancePerCard ? (
                      <div className='flex processing-fee-parent align-items-center'>
                        <h4 className={`fw-bold mb-0 text-black${cardInfo?.isAcceptMastercardCardConditions?.value ? '' : ' d-none'}`}>Fee</h4>
                        <div className='d-flex align-items-center'>
                          <h4 className={`fw-bold mb-0 text-black${cardInfo?.isAcceptMastercardCardConditions?.value ? '' : ' d-none'}`}>Amount</h4>
                          <ThreeStateToggleButton customClass='ms-auto' onChange={(checked) => onCardConditionsChange('isAcceptMastercardCardConditions', { label: `${checked}`, value: checked })} checked={cardInfo?.isAcceptMastercardCardConditions?.value} />
                        </div>
                      </div>
                    ) :
                      <div></div>}
                  </div>
                )
              }
              {
                ((showMaster && showAcceptancePerCard) || (showChildMaster && showChildAcceptancePerCard)) && !cardInfo[columns[48].name]?.value && (
                  <div className="accept-item flex-column">
                    {showAcceptancePerCard && (
                      showMaster && cardInfo?.isAcceptMastercardCardConditions?.value && (
                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Mastercard Processing Fee</span>
                          {!isFromList && (
                            <div></div>
                          )}
                          {showMaster ? (
                            <div className='processing-fee-parent flex'>
                              <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                                <div className='d-flex'>
                                  <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[67].name]?.value || '$',
                                        value: cardInfo[columns[67].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('mastercardProcessingFeeType', item, 'feeValue', 'mastercardProcessingFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[68].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[68].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[67].name]?.value || cardInfo[columns[67].name].value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[67].name]?.value || cardInfo[columns[67].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <button className='ms-2 show-option-btn' disabled={(!cardInfo?.mastercardProcessingFeeValue?.value || showMasterSecondProcessingFee) ? true : false} onClick={() => { handleUpdateCardFeeInfo('showMasterSecondProcessingFee', true) }}> + </button>
                                </div>

                                {showMasterSecondProcessingFee && (
                                  <div className='d-flex'>
                                    <div className='flex processing-fee-dropdown-parent align-center'>
                                      <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                        <Select // flex-sm-grow-0
                                          menuMaxHeight={48}
                                          className="processing-fee-dropdown h4 mb-0"
                                          options={
                                            [
                                              {
                                                label: '$',
                                                value: '$',
                                              },
                                              {
                                                label: '%',
                                                value: '%',
                                              },
                                            ]
                                          }
                                          value={{
                                            label: cardInfo?.mastercardSecondProcessingFeeType?.value || '$',
                                            value: cardInfo?.mastercardSecondProcessingFeeType?.value || '$'
                                          }}
                                          onChange={(item) => { handleUpdateCardFeeInfo('mastercardSecondProcessingFeeType', item, 'feeValue', 'mastercardSecondProcessingFeeValue') }}
                                        />
                                        <input
                                          className='search-input'
                                          value={cardInfo?.mastercardSecondProcessingFeeValue?.value || ''}
                                          onChange={(e) => onChangeCardInfo('mastercardSecondProcessingFeeValue', { label: e.target.value, value: e.target.value }, (!cardInfo?.mastercardSecondProcessingFeeType?.value || cardInfo.mastercardSecondProcessingFeeType?.value === '$') ? 'currency' : 'percent')}
                                          placeholder={(!cardInfo?.mastercardSecondProcessingFeeType?.value || cardInfo?.mastercardSecondProcessingFeeType?.value === '$') ? '1,234.00' : '12.50'}
                                        />
                                      </div>
                                      <button className='ms-2 hide-option-btn'
                                        onClick={() => {
                                          handleUpdateCardFeeInfo('showMasterSecondProcessingFee', false);
                                          onChangeCardInfo('mastercardSecondProcessingFeeValue', { label: '', value: '' }, cardInfo.mastercardSecondProcessingFeeType?.value === '$' ? 'currency' : 'percent')
                                        }}
                                      > - </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div></div>
                            </div>
                          ) : <div></div>}
                        </div>
                      )
                    )}

                    {(cardInfo?.isAcceptMastercardCardConditions?.value || childCardInfo?.isAcceptMastercardCardConditions?.value) && (
                      <>
                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Mastercard Minimum Payment:</span>
                          {!isFromList && (showChildMaster && showChildAcceptancePerCard && childCardInfo?.isAcceptMastercardCardConditions?.value ?
                            <div className='processing-fee-parent flex'>
                              <div></div>
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {childCardInfo[columns[18].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${childCardInfo[columns[18].name]?.value ? 'has-value' : ''}`}
                                    value={childCardInfo[columns[18].name]?.value || ''}
                                    disabled={true}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                <div></div>
                              </div>
                            </div>
                            : <div></div>
                          )}
                          {showMaster && showAcceptancePerCard && cardInfo?.isAcceptMastercardCardConditions?.value ?
                            <div className='processing-fee-parent flex'>
                              {showMasterMinFee ? (
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[69].name]?.value || '$',
                                        value: cardInfo[columns[69].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('mastercardMinPaymentFeeType', item, 'feeValue', 'mastercardMinPaymentFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[70].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[70].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[69].name]?.value || cardInfo[columns[69].name]?.value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[69].name]?.value || cardInfo[columns[69].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <span>Fee if under</span>
                                </div>
                              )
                                : <div></div>}
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {cardInfo[columns[18].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${cardInfo[columns[18].name]?.value ? 'has-value' : ''}`}
                                    value={cardInfo[columns[18].name]?.value || ''}
                                    onChange={(e) => onChangeCardInfo(columns[18].name, { label: e.target.value, value: e.target.value }, 'currency')}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                {showMasterMinFee ?
                                  <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showMasterMinFee', false) }}> - </button>
                                  :
                                  <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showMasterMinFee', true) }}> + </button>
                                }
                              </div>
                            </div>
                            : <div></div>
                          }
                        </div>

                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Mastercard Maximum Payment:</span>
                          {!isFromList && (showChildMaster && showChildAcceptancePerCard && childCardInfo?.isAcceptMastercardCardConditions?.value ?
                            <div className='processing-fee-parent flex'>
                              <div></div>
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {childCardInfo[columns[19].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${childCardInfo[columns[19].name]?.value ? 'has-value' : ''}`}
                                    value={childCardInfo[columns[19].name]?.value || ''}
                                    disabled={true}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                <div></div>
                              </div>
                            </div>
                            : <div></div>
                          )}
                          {showMaster && showAcceptancePerCard && cardInfo?.isAcceptMastercardCardConditions?.value ?
                            <div className='processing-fee-parent flex'>
                              {showMasterMaxFee ? (
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[71].name]?.value || '$',
                                        value: cardInfo[columns[71].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('mastercardMaxPaymentFeeType', item, 'feeValue', 'mastercardMaxPaymentFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[72].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[72].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[71].name]?.value || cardInfo[columns[71].name]?.value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[71].name]?.value || cardInfo[columns[71].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <span>Fee if over</span>
                                </div>
                              )
                                : <div></div>}
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {cardInfo[columns[19].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${cardInfo[columns[19].name]?.value ? 'has-value' : ''}`}
                                    value={cardInfo[columns[19].name]?.value || ''}
                                    onChange={(e) => onChangeCardInfo(columns[19].name, { label: e.target.value, value: e.target.value }, 'currency')}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                {showMasterMaxFee ?
                                  <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showMasterMaxFee', false) }}> - </button>
                                  :
                                  <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showMasterMaxFee', true) }}> + </button>
                                }
                              </div>
                            </div>
                            : <div></div>
                          }
                        </div>

                        <div className="row flex justify-space-between align-center g-0">
                          <span className="name">Incremental Fee:</span>
                          {!isFromList && (showChildMaster && showChildAcceptancePerCard && childCardInfo?.isAcceptMastercardCardConditions?.value ? (
                            <div className='processing-fee-parent flex'>
                              <div></div>
                              <div className='flex payment-parent'>
                                <div className="search-input-parent currency">
                                  {childCardInfo[columns[75].name]?.value ?
                                    <span>$</span>
                                    :
                                    ''
                                  }
                                  <input
                                    type="text"
                                    className={`search-input ${childCardInfo[columns[75].name]?.value ? 'has-value' : ''}`}
                                    value={childCardInfo[columns[75].name]?.value || ''}
                                    disabled={true}
                                    placeholder='$ 1,234.00'
                                  />
                                </div>
                                <div></div>
                              </div>
                            </div>
                          ) : <div></div>)}
                          {showMaster && showAcceptancePerCard && cardInfo?.isAcceptMastercardCardConditions?.value ? (
                            <div className='processing-fee-parent flex'>
                              {showMasterIncrementalFee ? (
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child'>
                                    <Select
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo[columns[73].name]?.value || '$',
                                        value: cardInfo[columns[73].name]?.value || '$'
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('mastercardIncrementalFeeType', item, 'feeValue', 'mastercardIncrementalFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo[columns[74].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[74].name, { label: e.target.value, value: e.target.value }, (!cardInfo[columns[73].name]?.value || cardInfo[columns[73].name]?.value === '$') ? 'currency' : 'percent')}
                                      placeholder={(!cardInfo[columns[73].name]?.value || cardInfo[columns[73].name]?.value === '$') ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <span>Fee for every</span>
                                </div>
                              )
                                : <div></div>}
                              <div className='flex payment-parent'>
                                {showMasterIncrementalFee ? (
                                  <div className="search-input-parent currency">
                                    {cardInfo[columns[75].name]?.value ?
                                      <span>$</span>
                                      :
                                      ''
                                    }
                                    <input
                                      type="text"
                                      className={`search-input ${cardInfo[columns[75].name]?.value ? 'has-value' : ''}`}
                                      value={cardInfo[columns[75].name]?.value || ''}
                                      onChange={(e) => onChangeCardInfo(columns[75].name, { label: e.target.value, value: e.target.value }, 'currency')}
                                      placeholder='$ 1,234.00'
                                    />
                                  </div>
                                )
                                  : <div></div>}
                                {showMasterIncrementalFee ?
                                  <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showMasterIncrementalFee', false) }}> - </button>
                                  :
                                  <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showMasterIncrementalFee', true) }}> + </button>
                                }
                              </div>
                            </div>
                          ) : <div></div>}
                        </div>

                        <div className="accept-item">
                          <h4 className='fw-bold toggle-item-text text-black mb-0'>Variable Fee:</h4>
                          {!isFromList && (showChildMaster && showChildAcceptancePerCard && childCardInfo?.isAcceptMastercardCardConditions?.value ?
                            <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo['isAcceptMasterCardVariableFee']?.value} isDisabled={true} /></div>
                            : <div></div>)}
                          {showMaster && showAcceptancePerCard && cardInfo?.isAcceptMastercardCardConditions?.value ? (
                            <>
                              <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo['isAcceptMasterCardVariableFee']?.value} onChange={(checked) => onChangeCardInfo('isAcceptMasterCardVariableFee', { label: `${checked}`, value: checked })} /></div>
                            </>
                          ) : <div></div>}
                        </div>
                      </>
                    )}
                  </div>
                )
              }
            </>
          }

          {/* <div className="accept-item">
            <h4 className='fw-bold toggle-item-text text-black mb-0'>Accepts Discover:</h4>
            {showAcceptancePerCard ? (
              <>
                <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo[columns[3].name].value} onChange={(checked) => onChangeCardInfo(columns[3].name, { label: `${checked}`, value: checked })} /></div>
              </>
            ) :
              <div></div>
            }
            <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo[columns[3].name].value} isDisabled={true} /></div>
          </div>
          {
            (showDiscover || showChildDiscover) && (Object.keys(deliveryMethodsFeeValues).length === 0) && (
              <div className="accept-item">
                <h4 className='fw-bold text-black mb-0'>Discover Processing Fees:</h4>
                {showDiscover && showAcceptancePerCard ? (
                  <div className='flex processing-fee-parent'>
                    <h4 className='fw-bold mb-0 text-black'>Fee</h4>
                    <h4 className='fw-bold mb-0 text-black'>Amount</h4>
                  </div>
                ) :
                  <div></div>}
                {showChildDiscover ? (
                  <div className='flex processing-fee-parent'>
                    <h4></h4>
                    <h4 className='fw-bold mb-0 text-black'>Amount</h4>
                  </div>
                ) :
                  <div></div>}
              </div>
            )
          }
          {
            (showDiscover || showChildDiscover) && (Object.keys(deliveryMethodsFeeValues).length === 0) && (
              <div className="accept-item flex-column">
                {showAcceptancePerCard && (
                  showDiscover && (
                    <div className="row flex justify-space-between align-center g-0">
                      <span className="name">Discover Processing Fee</span>
                      {showDiscover ? (
                        <div className='processing-fee-parent flex'>
                          <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                            <div className='d-flex'>
                              <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                <Select
                                  className="processing-fee-dropdown h4 mb-0"
                                  options={
                                    [
                                      {
                                        label: '$',
                                        value: '$',
                                      },
                                      {
                                        label: '%',
                                        value: '%',
                                      },
                                    ]
                                  }
                                  value={{
                                    label: cardInfo[columns[76].name].value,
                                    value: cardInfo[columns[76].name].value,
                                  }}
                                  onChange={(item) => { handleUpdateCardFeeInfo('discoverProcessingFeeType', item, 'feeValue', 'dicoverProcessingFeeValue') }}
                                />
                                <input
                                  className='search-input'
                                  value={cardInfo[columns[77].name]?.value || ''}
                                  onChange={(e) => onChangeCardInfo(columns[77].name, { label: e.target.value, value: e.target.value }, cardInfo[columns[76].name].value === '$' ? 'currency' : 'percent')}
                                  placeholder={cardInfo[columns[76].name].value === '$' ? '1,234.00' : '12.50'}
                                />
                              </div>
                              <button className='ms-2 show-option-btn' disabled={(!cardInfo?.discoverProcessingFeeValue?.value || showDiscoverSecondProcessingFee) ? true : false} onClick={() => { handleUpdateCardFeeInfo('showDiscoverSecondProcessingFee', true) }}> + </button>
                            </div>

                            {showDiscoverSecondProcessingFee && (
                              <div className='d-flex'>
                                <div className='flex processing-fee-dropdown-parent align-center'>
                                  <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                    <Select // flex-sm-grow-0
                                      menuMaxHeight={48}
                                      className="processing-fee-dropdown h4 mb-0"
                                      options={
                                        [
                                          {
                                            label: '$',
                                            value: '$',
                                          },
                                          {
                                            label: '%',
                                            value: '%',
                                          },
                                        ]
                                      }
                                      value={{
                                        label: cardInfo?.discoverSecondProcessingFeeType?.value || '',
                                        value: cardInfo?.discoverSecondProcessingFeeType?.value || '',
                                      }}
                                      onChange={(item) => { handleUpdateCardFeeInfo('discoverSecondProcessingFeeType', item, 'feeValue', 'discoverSecondProcessingFeeValue') }}
                                    />
                                    <input
                                      className='search-input'
                                      value={cardInfo?.discoverSecondProcessingFeeValue?.value || ''}
                                      onChange={(e) => onChangeCardInfo('discoverSecondProcessingFeeValue', { label: e.target.value, value: e.target.value }, cardInfo.discoverSecondProcessingFeeType?.value === '$' ? 'currency' : 'percent')}
                                      placeholder={cardInfo?.discoverSecondProcessingFeeType?.value === '$' ? '1,234.00' : '12.50'}
                                    />
                                  </div>
                                  <button className='ms-2 hide-option-btn'
                                    onClick={() => {
                                      handleUpdateCardFeeInfo('showDiscoverSecondProcessingFee', false);
                                      onChangeCardInfo('discoverSecondProcessingFeeValue', { label: '', value: '' }, cardInfo.discoverSecondProcessingFeeType?.value === '$' ? 'currency' : 'percent')
                                    }}
                                  > - </button>
                                </div>
                              </div>
                            )}
                          </div>
                          <div></div>
                        </div>
                      ) : <div></div>}
                      <div></div>
                    </div>
                  )
                )}
                <div className="row flex justify-space-between align-center g-0">
                  <span className="name">Discover Minimum Payment:</span>
                  {showDiscover && showAcceptancePerCard ?
                    <div className='processing-fee-parent flex'>
                      {showDiscoverMinFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: cardInfo[columns[78].name].value,
                                value: cardInfo[columns[78].name].value,
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('discoverMinFeeType', item, 'feeValue', 'discoverMinFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={cardInfo[columns[79].name]?.value || ''}
                              onChange={(e) => onChangeCardInfo(columns[79].name, { label: e.target.value, value: e.target.value }, cardInfo[columns[78].name].value === '$' ? 'currency' : 'percent')}
                              placeholder={cardInfo[columns[78].name].value === '$' ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <span>Fee if under</span>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {cardInfo[columns[23].name]?.value ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${cardInfo[columns[23].name]?.value ? 'has-value' : ''}`}
                            value={cardInfo[columns[23].name]?.value || ''}
                            onChange={(e) => onChangeCardInfo(columns[23].name, { label: e.target.value, value: e.target.value }, 'currency')}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        {showDiscoverMinFee ?
                          <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showDiscoverMinFee', false) }}> - </button>
                          :
                          <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showDiscoverMinFee', true) }}> + </button>
                        }
                      </div>
                    </div>
                    : <div></div>
                  }
                  {showChildDiscover ?
                    <div className='processing-fee-parent flex'>
                      <div></div>
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {childCardInfo[columns[23].name]?.value ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${childCardInfo[columns[23].name]?.value ? 'has-value' : ''}`}
                            value={childCardInfo[columns[23].name]?.value || ''}
                            disabled={true}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        <div></div>
                      </div>
                    </div>
                    : <div></div>
                  }
                </div>
                <div className="row flex justify-space-between align-center g-0">
                  <span className="name">Discover Maximum Payment:</span>
                  {showDiscover && showAcceptancePerCard ?
                    <div className='processing-fee-parent flex'>
                      {showDiscoverMaxFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: cardInfo[columns[80].name].value,
                                value: cardInfo[columns[80].name].value,
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('discoverMaxFeeType', item, 'feeValue', 'discoverMaxFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={cardInfo[columns[81].name]?.value || ''}
                              onChange={(e) => onChangeCardInfo(columns[81].name, { label: e.target.value, value: e.target.value }, cardInfo[columns[80].name].value === '$' ? 'currency' : 'percent')}
                              placeholder={cardInfo[columns[80].name].value === '$' ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <span>Fee if over</span>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {cardInfo[columns[24].name]?.value ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${cardInfo[columns[24].name]?.value ? 'has-value' : ''}`}
                            value={cardInfo[columns[24].name]?.value || ''}
                            onChange={(e) => onChangeCardInfo(columns[24].name, { label: e.target.value, value: e.target.value }, 'currency')}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        {showDiscoverMaxFee ?
                          <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showDiscoverMaxFee', false) }}> - </button>
                          :
                          <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showDiscoverMaxFee', true) }}> + </button>
                        }
                      </div>
                    </div>
                    : <div></div>
                  }
                  {showChildDiscover ?
                    <div className='processing-fee-parent flex'>
                      <div></div>
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {childCardInfo[columns[24].name]?.value ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${childCardInfo[columns[24].name]?.value ? 'has-value' : ''}`}
                            value={childCardInfo[columns[24].name]?.value || ''}
                            disabled={true}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        <div></div>
                      </div>
                    </div>
                    : <div></div>
                  }
                </div>


                <div className="row flex justify-space-between align-center g-0">
                  <span className="name">Incremental Fee:</span>
                  {showDiscover && showAcceptancePerCard ? (
                    <div className='processing-fee-parent flex'>
                      {showDiscoverIncrementalFee ? (
                        <div className='flex processing-fee-dropdown-parent align-center'>
                          <div className='flex processing-fee-dropdown-child'>
                            <Select
                              className="processing-fee-dropdown h4 mb-0"
                              options={
                                [
                                  {
                                    label: '$',
                                    value: '$',
                                  },
                                  {
                                    label: '%',
                                    value: '%',
                                  },
                                ]
                              }
                              value={{
                                label: cardInfo[columns[82].name].value,
                                value: cardInfo[columns[82].name].value,
                              }}
                              onChange={(item) => { handleUpdateCardFeeInfo('discoverIncrementalFeeType', item, 'feeValue', 'discoverIncrementalFeeValue') }}
                            />
                            <input
                              className='search-input'
                              value={cardInfo[columns[83].name]?.value || ''}
                              onChange={(e) => onChangeCardInfo(columns[83].name, { label: e.target.value, value: e.target.value }, cardInfo[columns[82].name].value === '$' ? 'currency' : 'percent')}
                              placeholder={cardInfo[columns[82].name].value === '$' ? '1,234.00' : '12.50'}
                            />
                          </div>
                          <span>Fee for every</span>
                        </div>
                      )
                        : <div></div>}
                      <div className='flex payment-parent'>
                        {showDiscoverIncrementalFee ? (
                          <div className="search-input-parent currency">
                            {cardInfo[columns[84].name]?.value ?
                              <span>$</span>
                              :
                              ''
                            }
                            <input
                              type="text"
                              className={`search-input ${cardInfo[columns[84].name]?.value ? 'has-value' : ''}`}
                              value={cardInfo[columns[84].name]?.value || ''}
                              onChange={(e) => onChangeCardInfo(columns[84].name, { label: e.target.value, value: e.target.value }, 'currency')}
                              placeholder='$ 1,234.00'
                            />
                          </div>
                        )
                          : <div></div>}
                        {showDiscoverIncrementalFee ?
                          <button className='hide-option' onClick={() => { handleUpdateCardFeeInfo('showDiscoverIncrementalFee', false) }}> - </button>
                          :
                          <button className='show-option' onClick={() => { handleUpdateCardFeeInfo('showDiscoverIncrementalFee', true) }}> + </button>
                        }
                      </div>
                    </div>
                  ) : <div></div>}
                  {showChildDiscover ? (
                    <div className='processing-fee-parent flex'>
                      <div></div>
                      <div className='flex payment-parent'>
                        <div className="search-input-parent currency">
                          {childCardInfo[columns[84].name].value ?
                            <span>$</span>
                            :
                            ''
                          }
                          <input
                            type="text"
                            className={`search-input ${childCardInfo[columns[84].name].value ? 'has-value' : ''}`}
                            value={childCardInfo[columns[84].name].value || ''}
                            disabled={true}
                            placeholder='$ 1,234.00'
                          />
                        </div>
                        <div></div>
                      </div>
                    </div>
                  ) : <div></div>}
                </div>
              </div>
            )
          } */}

          {
            ((showAmex || showVisa || showMaster) || (showChildAmex || showChildVisa || showChildMaster)) && (
              <>
                {Object.keys(deliveryMethodsFeeValues).length === 0 && (
                  <div className="accept-item">
                    <div className="row flex justify-space-between align-center g-0">
                      <h4 className='fw-bold text-black mb-0'>Token Configuration:</h4>
                      {!isFromList && ((showChildAmex || showChildVisa || showChildMaster) ?
                        <div className='item token-configuration-options-list'>
                          <RadioGroup name="radioList" className='flex' inline={true} value={childCardInfo[columns[27].name]?.value || ''}>
                            <Radio value="single-use-max-amount">Single-Use Max Amount</Radio>
                            <Radio value="multi-use">Multi-Use</Radio>
                            <Radio value="reloadable">Reloadable</Radio>
                          </RadioGroup>
                        </div>
                        : <div></div>
                      )}
                      {(showAmex || showVisa || showMaster) ?
                        <div className='item token-configuration-options-list'>
                          <RadioGroup name="radioList" className='flex' inline={true} value={cardInfo[columns[27].name]?.value || ''}>
                            <Radio value="single-use-max-amount" onChange={() => onChangeCardInfo(columns[27].name, { label: 'single-use-max-amount', value: 'single-use-max-amount' })}>Single-Use Max Amount</Radio>
                            <Radio value="multi-use" onChange={() => onChangeCardInfo(columns[27].name, { label: 'multi-use', value: 'multi-use' })}>Multi-Use</Radio>
                            <Radio value="reloadable" onChange={() => onChangeCardInfo(columns[27].name, { label: 'reloadable', value: 'reloadable' })}>Reloadable</Radio>
                          </RadioGroup>
                        </div>
                        : <div></div>
                      }
                    </div>
                  </div>
                )}

                <div className="accept-item">
                  <div className="row flex justify-space-between align-center g-0">
                    <h4 className='fw-bold text-black mb-0'>Card Authorization Form:</h4>
                    {!isFromList && ((showChildAmex || showChildVisa || showChildMaster) ?
                      <div className='item card-authorization-form direct-col'>
                        <CheckboxComponent
                          label='Card Authorization Form'
                          checked={childCardInfo[columns[28].name]?.value}
                          disabled={true}
                        />
                        {childCardInfo[columns[28].name]?.value && (
                          <DragDropFileUpload
                            currentFileName={childCardInfo[columns[47].name]?.value}
                            customClassName='upload-card-authorization-form-file'
                            accept='*.*'
                            isDisabled={true}
                          />
                        )}
                      </div>
                      : <div></div>
                    )}
                    {(showAmex || showVisa || showMaster) ?
                      <div className='item card-authorization-form direct-col'>
                        <CheckboxComponent
                          label='Card Authorization Form'
                          onChange={(checked) => { onChangeCardInfo(columns[28].name, { label: `${checked}`, value: checked }) }}
                          checked={cardInfo[columns[28].name]?.value}
                        />
                        {cardInfo[columns[28].name]?.value && (
                          <DragDropFileUpload
                            currentFileName={cardAuthorizationFormFile?.name}
                            onFileChosen={handleFileChosen}
                            customClassName='upload-card-authorization-form-file'
                            accept='*.*'
                          />
                        )}
                      </div>
                      : <div></div>
                    }
                  </div>
                </div>

                <div className="item accept-item align-flex-start">
                  <h4 className='fw-bold text-black mb-0'>How Do They Receive Payment:</h4>
                  {!isFromList && ((showChildAmex || showChildVisa || showChildMaster) ?
                    <div className='receive-payment-container'>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Email'
                            disabled={true}
                            checked={childCardInfo[columns[29].name]?.value}
                          />
                          {childCardInfo[columns[29].name]?.value && (
                            getRemittanceRequirements('emailRemitRequirements', 'child')
                          )}
                        </div>
                        {childCardInfo[columns[29].name]?.value && (
                          <>
                            <div className='add-more-email-container flex align-center'>
                              <input
                                type="text"
                                className="search-input"
                                name={"card-email-name"}
                                value={''}
                                disabled={true}
                                placeholder='email@gmail.com'
                              />
                              <button className='add-more-email flex align-center'>
                                <AiOutlinePlusCircle color="#65B3E9" size={26} />
                                Add
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Phone'
                            disabled={true}
                            checked={childCardInfo[columns[30].name]?.value}
                          />
                          {childCardInfo[columns[30].name]?.value && (
                            getRemittanceRequirements('phoneRemitRequirements', 'child')
                          )}
                        </div>
                        {childCardInfo[columns[30].name]?.value && (
                          <>
                            <div className='receive-payment-portals d-flex flex-wrap'>
                              <CheckboxComponent
                                label='POTS'
                                onChange={(checked) => { onChangeCardInfo(columns[97].name, { label: `${checked}`, value: checked }) }}
                                checked={cardInfo[columns[97].name]?.value}
                                disabled={true}
                              />
                              <CheckboxComponent
                                label='IVR'
                                onChange={(checked) => { onChangeCardInfo(columns[98].name, { label: `${checked}`, value: checked }) }}
                                checked={cardInfo[columns[98].name]?.value}
                                disabled={true}
                              />
                            </div>
                            {childCardInfo[columns[97].name].value && (
                              <div className="phone-input-parent flex justify-content-center flex-column">
                                <h4 className='fw-bold text-black mb-0'>POTS</h4>
                                <div className='d-flex align-center gap-2'>
                                  <div className='d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-xxl-row'>
                                    <ReactPhoneInput
                                      className='phone-input-parent mt-0'
                                      country={'us'}
                                      value={childCardInfo[columns[33].name]?.value || ''}
                                      disabled={true}
                                      buttonClass='border-0 border-end border-dark'
                                      inputProps={{
                                        className: 'form-control border-0'
                                      }}
                                    />
                                    <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                      <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                      <input type="text" value={childCardInfo[columns[85].name]?.value || ''} className="search-input mt-0 shadow-none form-control w-auto border-0 ps-3 pe-3" placeholder="phone extension" disabled={true} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {childCardInfo[columns[98].name].value && (
                              <div className="phone-input-parent flex justify-content-center flex-column mt-4">
                                <h4 className='fw-bold text-black mb-0'>IVR</h4>
                                <div className='d-flex align-center gap-2'>
                                  <div className='d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-xxl-row'>
                                    <ReactPhoneInput
                                      className='phone-input-parent mt-0'
                                      country={'us'}
                                      value={childCardInfo[columns[99].name]?.value || ''}
                                      disabled={true}
                                      buttonClass='border-0 border-end border-dark'
                                      inputProps={{
                                        className: 'form-control border-0'
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Fax'
                            disabled={true}
                            checked={childCardInfo[columns[31].name]?.value}
                          />
                          {childCardInfo[columns[31].name]?.value && (
                            getRemittanceRequirements('faxRemitRequirements', 'child')
                          )}
                        </div>
                        {childCardInfo[columns[31].name].value && (
                          <input
                            type="text"
                            className="search-input"
                            value={childCardInfo[columns[34].name]?.value || ''}
                            disabled={true}
                            placeholder='786-874-5678'
                          />
                        )}
                      </div>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Online'
                            disabled={true}
                            checked={childCardInfo[columns[32].name]?.value}
                          />
                          {childCardInfo[columns[32].name].value && (
                            getRemittanceRequirements('onlineRemitRequirements', 'child')
                          )}
                        </div>
                        {childCardInfo[columns[32].name].value && (
                          <div className='receive-payment-portals flex flex-wrap'>
                            <CheckboxComponent
                              label='E-commerce'
                              disabled={true}
                              checked={childCardInfo[columns[35].name]?.value}
                            />
                            <CheckboxComponent
                              label='Portal'
                              disabled={true}
                              checked={childCardInfo[columns[36].name]?.value}
                            />
                            <CheckboxComponent
                              label='3rd Party Portal'
                              disabled={true}
                              checked={childCardInfo[columns[37].name]?.value}
                            />
                            <CheckboxComponent
                              label='In-App'
                              disabled={true}
                              checked={childCardInfo[columns[38].name]?.value}
                            />
                          </div>
                        )}
                        {childCardInfo[columns[32].name].value && childCardInfo[columns[36].name].value && (
                          <div className='receive-payment-item'>
                            <h4 className='fw-bold text-black mb-0'>Portal URL</h4>
                            <input
                              type="text"
                              className="search-input"
                              placeholder="https://portal.com"
                              disabled={true}
                              value={childCardInfo[columns[39].name]?.value}
                            />
                          </div>
                        )}
                        {childCardInfo[columns[32].name].value && childCardInfo[columns[37].name].value && (
                          <div className='receive-payment-item'>
                            <h4 className='fw-bold text-black mb-0'>3rd Party Portal URL</h4>
                            <input
                              type="text"
                              className="search-input"
                              placeholder="https://thirdpartyportal.com"
                              disabled={true}
                              value={childCardInfo[columns[40].name]?.value}
                            />
                          </div>
                        )}
                      </div>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Point of Sale'
                            disabled={true}
                            checked={childCardInfo[columns[41].name]?.value}
                          />
                          {childCardInfo[columns[41].name].value && (
                            getRemittanceRequirements('posRemitRequirements', 'child')
                          )}
                        </div>
                      </div>
                    </div>
                    : <div></div>
                  )}
                  {(showAmex || showVisa || showMaster) ?
                    <div className='receive-payment-container'>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Email'
                            onChange={(checked) => { onChangeCardInfo(columns[29].name, { label: `${checked}`, value: checked }) }}
                            checked={cardInfo[columns[29].name].value}
                          />
                          {cardInfo[columns[29].name].value && (
                            getRemittanceRequirements('emailRemitRequirements', 'master')
                          )}
                        </div>
                        {cardInfo[columns[29].name].value && (
                          <>
                            <div className='add-more-email-container flex align-center'>
                              <div className='email-type-parent flex'>
                                <div className={`phone-input-parent flex align-center position-relative${suppliercardEmailsInfo?.[0]?.emailContactId ? ' input-group h-100 align-items-center' : ''}`}>
                                  {suppliercardEmailsInfo?.[0]?.emailContactId && (
                                    <span role='button' class='border-end-0 input-group-text text-red px-3 fs-2 fw-bold mt-2 mb-0' onClick={() => { handleRemoveContact('email') }} style={{ height: '48px' }}>X</span>
                                  )}
                                  <input
                                    type="text"
                                    className="search-input text-primary border border-primary"
                                    style={{ marginLeft: suppliercardEmailsInfo?.[0]?.emailContactId ? '-5px' : '0' }}
                                    value={suppliercardEmailsInfo?.[0]?.email || ''}
                                    onChange={e => handleEmailsChange(e, 0)}
                                    placeholder='email@gmail.com'
                                    // onBlur={() => { handleEmailFocusOut(suppliercardEmailsInfo?.[0]) }}
                                    title={suppliercardEmailsInfo?.[0]?.email || ''}
                                    onClick={() => { onPhoneEmailClick('email', 'phone', 'ivrPhone') }}
                                    onMouseOver={(e) => { onContactMouseHover(e) }}
                                    onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                    data-contact-id={suppliercardEmailsInfo?.[0]?.emailContactId || ''}
                                    autoComplete='no-email'
                                  />
                                  {suppliercardEmailsInfo?.[0]?.email && !showAllContacts?.email && (
                                    <ContactView contact={currentContact} />
                                  )}
                                  {showAllContacts?.email && (
                                    <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                  )}
                                  {isValidatingEmail && suppliercardEmailsInfo?.[0]?.email && (<Loader />)}
                                  {suppliercardEmailsInfo?.[0]?.email && !isValidatingEmail && isEmailValid !== '' &&
                                    (isEmailValid ?
                                      <BsCheckSquare className='validation-icon' color="#067911" size={26} />
                                      :
                                      <>
                                        <BsXSquare className='validation-icon' color="#f75a52" size={26} />
                                        {/* <MdOutlineChangeCircle
                                          className='validation-icon'
                                          title='Retry'
                                          role='button'
                                          color="#14438b"
                                          size={30}
                                          onClick={() => { handleEmailFocusOut(suppliercardEmailsInfo?.[0]?.email, true) }}
                                        /> */}
                                      </>
                                    )
                                  }
                                </div>
                                <Select
                                  className="card-email-type-selector mb-0 h4"
                                  options={
                                    [
                                      {
                                        label: 'Remittance',
                                        value: 'Remittance',
                                      },
                                      {
                                        label: 'Payment',
                                        value: 'Payment',
                                      },
                                    ]
                                  }
                                  value={{
                                    label: cardEmailType || '',
                                    value: cardEmailType || '',
                                  }}
                                  onChange={(item) => onChangeCardInfo('emailType', item)}
                                />
                              </div>
                              <button className='add-more-email flex align-center' onClick={addMoreEmail}>
                                <AiOutlinePlusCircle color="#65B3E9" size={26} />
                                Add
                              </button>
                            </div>
                            {emailValues.length > 0 && (
                              emailValues.every((email) => { return email === undefined }) ? '' : <h4 className='addedEmails fw-bold text-black mb-0'> Added Emails : </h4>
                            )}
                            {emailValues.map((value, index) => {
                              if (typeof (value) !== 'undefined') {
                                return (
                                  <div key={index} className="card-acceptance-more-emails-container">
                                    <h4 className='email-type fw-bold text-black mb-0'> <i>{value?.["extra-email-name-" + (index + 1)]?.emailType === 'Remittance' ? 'Payment Remittance' : 'Payment'} : </i></h4>
                                    <div key={"extar-email-key" + (index + 1)} className="card-acceptance-more-emails flex position-relative">
                                      <input
                                        className={"text-primary search-input extra-email-" + (index + 1)}
                                        type="text"
                                        name={"extra-email-name-" + (index + 1)}
                                        value={value?.["extra-email-name-" + (index + 1)]?.email || ''}
                                        disabled={true}
                                        onMouseOver={(e) => { onContactMouseHover(e) }}
                                        onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                        data-contact-id={value?.["extra-email-name-" + (index + 1)]?.emailContactId || ''}
                                      ></input>
                                      {value?.["extra-email-name-" + (index + 1)]?.email && (
                                        <ContactView contact={currentContact} />
                                      )}
                                      <button className='remove-email flex align-center' onClick={() => removeEmail((index + 1))}>
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </>
                        )}
                      </div>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Phone'
                            onChange={(checked) => { onChangeCardInfo(columns[30].name, { label: `${checked}`, value: checked }) }}
                            checked={cardInfo[columns[30].name]?.value}
                          />
                          {cardInfo[columns[30].name]?.value && (
                            getRemittanceRequirements('phoneRemitRequirements', 'master')
                          )}
                        </div>
                        {cardInfo[columns[30].name]?.value && (
                          <>
                            <div className='receive-payment-portals d-flex flex-wrap'>
                              <CheckboxComponent
                                label='POTS'
                                onChange={(checked) => { onChangeCardInfo(columns[97].name, { label: `${checked}`, value: checked }) }}
                                checked={cardInfo[columns[97].name]?.value}
                              />
                              <CheckboxComponent
                                label='IVR'
                                onChange={(checked) => { onChangeCardInfo(columns[98].name, { label: `${checked}`, value: checked }) }}
                                checked={cardInfo[columns[98].name]?.value}
                              />
                            </div>
                            {cardInfo[columns[97].name].value && (
                              <div className="phone-input-parent flex justify-content-center flex-column">
                                <h4 className='fw-bold text-black mb-0'>POTS</h4>
                                <div className='d-flex align-center gap-2'>
                                  <div className={`d-flex border rounded phone-input-ext-container w-100 flex-column flex-xxl-row position-relative${cardInfo?.phoneContactId?.value ? ' input-group' : ''}`}>
                                    {cardInfo?.phoneContactId?.value && (
                                      <span role='button' class='border border-start-0 border-top-0 border-bottom-0 input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact('phone') }} >X</span>
                                    )}
                                    <input
                                      onClick={() => { onPhoneEmailClick('phone', 'email', 'ivrPhone') }}
                                      value={cardInfo[columns[33].name].value || ''}
                                      className={`basicvalue search-input h4 mb-0 text-primary border-0 ms-0`}
                                      onChange={e => onChangeCardInfo('cardPaymentByPhoneValue', { label: e.target.value, value: e.target.value }, 'phone')}
                                      onMouseOver={(e) => { onContactMouseHover(e) }}
                                      onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                      data-contact-id={cardInfo?.phoneContactId?.value || ''}
                                      autoComplete='no-phone'
                                    // onBlur={(event) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, null, supplierInfo[col.name]) }}
                                    />

                                    {cardInfo[columns[33].name].value && !showAllContacts?.phone && (
                                      <ContactView contact={currentContact} />
                                    )}
                                    {showAllContacts?.phone && (
                                      <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                    )}
                                    {/* <ReactPhoneInput
                                      className='phone-input-parent mt-0'
                                      country={'us'}
                                      value={cardInfo[columns[33].name]?.value || ''}
                                      onChange={(value, country, e, formattedValue) => { onChangeCardInfo(columns[33].name, { label: formattedValue, value: formattedValue }, 'phone', country, e) }}
                                      onBlur={(event, country) => { handlePhoneNumberFocusOut(event, country, cardInfo[columns[33].name]?.value, columns[33].name) }}
                                      countryCodeEditable={false}
                                      preferredCountries={['us']}
                                      onKeyDown={(e) => handleKeyDown(e, phoneInputRefname)}
                                      ref={phoneInputRefname}
                                      buttonClass='border-0 border-end border-dark'
                                      inputProps={{
                                        className: 'form-control border-0 shadow-none'
                                      }}
                                    /> */}
                                    <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                      <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                      <input
                                        type="text"
                                        className="search-input mt-0 shadow-none form-control w-auto border-0 ps-3 pe-3"
                                        placeholder="phone extension"
                                        value={cardInfo[columns[85].name]?.value || ''}
                                        onChange={(e) => { onChangeCardInfo(columns[85].name, { label: e.target.value, value: e.target.value }, 'extension') }}
                                        disabled={(!cardInfo[columns[33].name]?.value || !isPhoneValid || cardInfo[columns[33].name]?.value === countryCode) ? true : false}
                                      />
                                    </div>
                                  </div>
                                  {isValidatingPhone && cardInfo[columns[33].name]?.value && (<Loader />)}
                                  {cardInfo[columns[33].name]?.value && !isValidatingPhone && isPhoneValid !== '' &&
                                    (isPhoneValid ?
                                      <BsCheckSquare color="#067911" size={26} />
                                      :
                                      <BsXSquare color="#f75a52" size={26} />
                                    )
                                  }
                                </div>
                              </div>
                            )}
                            {cardInfo[columns[98].name].value && (
                              <div className="phone-input-parent flex justify-content-center flex-column mt-4">
                                <h4 className='fw-bold text-black mb-0'>IVR</h4>
                                <div className='d-flex align-center gap-2'>
                                  <div className={`d-flex border rounded phone-input-ext-container w-100 flex-column flex-xxl-row position-relative${cardInfo?.ivrPhoneContactId?.value ? ' input-group' : ''}`}>
                                    {cardInfo?.ivrPhoneContactId?.value && (
                                      <span role='button' class='border border-start-0 border-top-0 border-bottom-0 input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact('ivrPhone') }}>X</span>
                                    )}
                                    <input
                                      onClick={() => { onPhoneEmailClick('ivrPhone', 'email', 'phone') }}
                                      value={cardInfo[columns[99].name].value || ''}
                                      className={`basicvalue search-input h4 mb-0 text-primary border-0 ms-0`}
                                      onChange={e => onChangeCardInfo(columns[99].name, { label: e.target.value, value: e.target.value }, 'phone')}
                                      onMouseOver={(e) => { onContactMouseHover(e) }}
                                      onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                      data-contact-id={cardInfo?.ivrPhoneContactId?.value || ''}
                                      autoComplete='no-phone'
                                    // onBlur={(event) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, null, supplierInfo[col.name]) }}
                                    />
                                    {cardInfo[columns[99].name]?.value && !showAllContacts?.ivrPhone && (
                                      <ContactView contact={currentContact} />
                                    )}
                                    {showAllContacts?.ivrPhone && (
                                      <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={onCreateContact} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                    )}
                                    {/* <ReactPhoneInput
                                      className='phone-input-parent mt-0'
                                      country={'us'}
                                      value={cardInfo[columns[99].name]?.value || ''}
                                      onChange={(value, country, e, formattedValue) => { onChangeCardInfo(columns[99].name, { label: formattedValue, value: formattedValue }, 'phone', country, e) }}
                                      onBlur={(event, country) => { handlePhoneNumberFocusOut(event, country, cardInfo[columns[99].name]?.value, columns[99].name) }}
                                      countryCodeEditable={false}
                                      preferredCountries={['us']}
                                      onKeyDown={(e) => handleKeyDown(e, ivrPhoneInputRefname)}
                                      ref={ivrPhoneInputRefname}
                                      buttonClass='border-0 border-end border-dark'
                                      inputProps={{
                                        className: 'form-control border-0 shadow-none'
                                      }}
                                    /> */}
                                  </div>
                                  {isValidatingIVRPhone && cardInfo[columns[99].name]?.value && (<Loader />)}
                                  {cardInfo[columns[99].name]?.value && !isValidatingIVRPhone && isIVRPhoneValid !== '' &&
                                    (isIVRPhoneValid ?
                                      <BsCheckSquare color="#067911" size={26} />
                                      :
                                      <BsXSquare color="#f75a52" size={26} />
                                    )
                                  }
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Fax'
                            onChange={(checked) => { onChangeCardInfo(columns[31].name, { label: `${checked}`, value: checked }) }}
                            checked={cardInfo[columns[31].name]?.value}
                          />
                          {cardInfo[columns[31].name]?.value && (
                            getRemittanceRequirements('faxRemitRequirements', 'master')
                          )}
                        </div>
                        {cardInfo[columns[31].name]?.value && (
                          <input
                            type="text"
                            className="search-input"
                            value={cardInfo[columns[34].name].value || ''}
                            onChange={(e) => { onChangeCardInfo(columns[34].name, { label: e.target.value, value: e.target.value }, 'fax') }}
                            placeholder='786-874-5678'
                          />
                        )}
                      </div>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Online'
                            onChange={(checked) => { onChangeCardInfo(columns[32].name, { label: `${checked}`, value: checked }) }}
                            checked={cardInfo[columns[32].name]?.value}
                          />
                          {cardInfo[columns[32].name]?.value && (
                            getRemittanceRequirements('onlineRemitRequirements', 'master')
                          )}
                        </div>
                        {cardInfo[columns[32].name]?.value && (
                          <div className='receive-payment-portals flex flex-wrap'>
                            <CheckboxComponent
                              label='E-commerce'
                              onChange={(checked) => { onChangeCardInfo(columns[35].name, { label: `${checked}`, value: checked }) }}
                              checked={cardInfo[columns[35].name]?.value}
                            />
                            <CheckboxComponent
                              label='Portal'
                              onChange={(checked) => { onChangeCardInfo(columns[36].name, { label: `${checked}`, value: checked }) }}
                              checked={cardInfo[columns[36].name]?.value}
                            />
                            <CheckboxComponent
                              label='3rd Party Portal'
                              onChange={(checked) => { onChangeCardInfo(columns[37].name, { label: `${checked}`, value: checked }) }}
                              checked={cardInfo[columns[37].name]?.value}
                            />
                            <CheckboxComponent
                              label='In-App'
                              onChange={(checked) => { onChangeCardInfo(columns[38].name, { label: `${checked}`, value: checked }) }}
                              checked={cardInfo[columns[38].name]?.value}
                            />
                          </div>
                        )}
                        {cardInfo[columns[32].name]?.value && cardInfo[columns[36].name]?.value && (
                          <div className='receive-payment-item'>
                            <h4 className='fw-bold text-black mb-0'>Portal URL</h4>
                            <input
                              type="text"
                              className="search-input"
                              placeholder="https://portal.com"
                              onChange={(e) => { onChangeCardInfo(columns[39].name, { label: e.target.value, value: e.target.value }, 'url') }}
                              value={cardInfo[columns[39].name]?.value}
                            />
                          </div>
                        )}
                        {cardInfo[columns[32].name].value && cardInfo[columns[37].name].value && (
                          <div className='receive-payment-item'>
                            <h4 className='fw-bold text-black mb-0'>3rd Party Portal URL</h4>
                            <input
                              type="text"
                              className="search-input"
                              placeholder="https://thirdpartyportal.com"
                              onChange={(e) => { onChangeCardInfo(columns[40].name, { label: e.target.value, value: e.target.value }, 'url') }}
                              value={cardInfo[columns[40].name]?.value}
                            />
                          </div>
                        )}
                      </div>
                      <div className='receive-payment-item'>
                        <div className={`d-flex align-items-center`}>
                          <CheckboxComponent
                            label='Point of Sale'
                            onChange={(checked) => { onChangeCardInfo(columns[41].name, { label: `${checked}`, value: checked }) }}
                            checked={cardInfo[columns[41].name]?.value}
                          />
                          {cardInfo[columns[41].name]?.value && (
                            getRemittanceRequirements('posRemitRequirements', 'master')
                          )}
                        </div>
                      </div>
                    </div>
                    : <div></div>
                  }

                </div>

                <div className="accept-item">
                  <h4 className='fw-bold toggle-item-text text-black mb-0'>Standard Processing Time For Credit Card Payments:</h4>
                  {!isFromList && ((showChildAmex || showChildVisa || showChildMaster) ?
                    <Select
                      value={childCardInfo[columns[5].name]}
                      isDisabled={true}
                      className='h4 mb-0'
                    />
                    : <div></div>
                  )}
                  {(showAmex || showVisa || showMaster) ?
                    <Select
                      value={cardInfo[columns[5].name]}
                      onChange={(item) => onChangeCardInfo(columns[5].name, item)}
                      className='h4 mb-0'
                      options={[
                        {
                          label: '1 Day',
                          value: 1,
                        },
                        {
                          label: '2 Days',
                          value: 2,
                        },
                        {
                          label: '3 Days',
                          value: 3,
                        },
                        {
                          label: '4 Days',
                          value: 4,
                        },
                        {
                          label: '5 Days',
                          value: 5,
                        },
                      ]}
                    />
                    : <div></div>
                  }
                </div>

                <div className="accept-item">
                  <h4 className='fw-bold toggle-item-text text-black mb-0'>Card Payment Terms</h4>
                  {!isFromList && ((showChildAmex || showChildVisa || showChildMaster) ?
                    <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo[columns[42].name]?.value} isDisabled={true} /></div>
                    : <div></div>
                  )}
                  {(showAmex || showVisa || showMaster) ?
                    <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo[columns[42].name]?.value} onChange={(checked) => onChangeCardInfo(columns[42].name, { label: `${checked}`, value: checked })} /></div>
                    : <div></div>
                  }
                </div>

                <div className={`payment-terms ${(cardInfo[columns[42].name]?.value || childCardInfo[columns[42].name]?.value) && 'accept-item'}`}>
                  {(cardInfo[columns[42].name]?.value || childCardInfo[columns[42].name]?.value) && (
                    <h4 className='text-black fw-normal mb-0'> Payment Terms: </h4>
                  )}

                  {!isFromList && (childCardInfo[columns[42].name]?.value ? (
                    <div className="payment-terms">
                      <Select
                        className="payment-terms-selector h4 mb-0"
                        value={childCardInfo[columns[43].name]}
                        isDisabled={true}
                      />
                    </div>
                  )
                    : <div></div>
                  )}

                  {cardInfo[columns[42].name].value ? (
                    <div className="payment-terms">
                      <Select
                        className="payment-terms-selector h4 mb-0"
                        options={
                          paymentTermsOptions.map((element) => (
                            {
                              label: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days'),
                              value: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days')
                            }
                          ))
                        }
                        value={cardInfo[columns[43].name]}
                        onChange={(item) => onChangeCardInfo(columns[43].name, item)}
                      />
                    </div>
                  )
                    : <div></div>
                  }
                </div>

                <div className="accept-item">
                  <h4 className='fw-bold toggle-item-text text-black mb-0'> Do They Offer Discount By Card Payment? </h4>
                  {!isFromList && ((showChildAmex || showChildVisa || showChildMaster) ?
                    <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo[columns[44].name].value} isDisabled={true} /></div>
                    : <div></div>
                  )}
                  {(showAmex || showVisa || showMaster) ?
                    <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo[columns[44].name].value} onChange={(checked) => onChangeCardInfo(columns[44].name, { label: `${checked}`, value: checked })} /></div>
                    : <div></div>
                  }
                </div>

                {(cardInfo[columns[44].name].value || childCardInfo[columns[44].name].value) && (
                  <>
                    <div className="accept-item card-discount flex">
                      <h4 className='text-black fw-normal mb-0'> Card Discount: </h4>
                      {!isFromList && (childCardInfo[columns[44].name].value ?
                        <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                          <div className='d-flex ms-auto'>
                            <div className='flex processing-fee-dropdown-child flex-grow-1'>
                              <Select
                                className="processing-fee-dropdown card-discount-type-selector h4 mb-0"
                                options={
                                  [
                                    {
                                      label: '$',
                                      value: 'Dollar',
                                    },
                                    {
                                      label: '%',
                                      value: 'Percentage',
                                    },
                                  ]
                                }
                                value={childCardInfo[columns[45].name]}
                                isDisabled={true}
                              />
                              <input
                                type="text"
                                className="search-input card-discount-value-input h4 mb-0"
                                disabled={true}
                                value={childCardInfo[columns[46].name]?.value || ''}
                                placeholder={childCardInfo[columns[45].name]?.value === 'Dollar' ? '1,234.00' : '12.50'}
                              />
                            </div>
                          </div>
                        </div>
                        :
                        <div></div>
                      )}
                      {cardInfo[columns[44].name].value ?
                        <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                          <div className='d-flex ms-auto'>
                            <div className='flex processing-fee-dropdown-child flex-grow-1'>
                              <Select
                                isSearchable={false}
                                menuMaxHeight={48}
                                className="processing-fee-dropdown card-discount-type-selector h4 mb-0"
                                options={
                                  [
                                    {
                                      label: '$',
                                      value: 'Dollar',
                                    },
                                    {
                                      label: '%',
                                      value: 'Percentage',
                                    },
                                  ]
                                }
                                value={cardInfo[columns[45].name]}
                                onChange={(item) => onChangeCardInfo(columns[45]?.name, item, 'discounttype')}
                              />
                              <input
                                type="text"
                                className="search-input card-discount-value-input h4 mb-0"
                                onChange={(e) => { onChangeCardInfo(columns[46]?.name, { label: e.target.value, value: e.target.value }, cardInfo[columns[45].name]?.value === 'Dollar' ? 'currency' : 'percent') }}
                                value={cardInfo[columns[46].name]?.value || ''}
                                placeholder={cardInfo[columns[45].name]?.value === 'Dollar' ? '1,234.00' : '12.50'}
                              />
                            </div>
                          </div>
                        </div>
                        :
                        <div></div>
                      }
                    </div>
                  </>
                )
                }

                <div className="accept-item">
                  <h4 className='fw-bold toggle-item-text text-black mb-0'>Is Card Acceptance Product Specific?</h4>
                  {!isFromList && ((showChildAmex || showChildVisa || showChildMaster) ?
                    <div className='flex justify-end'><ThreeStateToggleButton checked={childCardInfo[columns[95].name]?.value} isDisabled={true} /></div>
                    : <div></div>
                  )}
                  {(showAmex || showVisa || showMaster) ?
                    <div className='flex justify-end'><ThreeStateToggleButton checked={cardInfo[columns[95].name]?.value} onChange={(checked) => onChangeCardInfo(columns[95]?.name, { label: `${checked}`, value: checked })} /></div>
                    : <div></div>
                  }
                </div>

                <div className={`payment-terms ${(cardInfo[columns[95].name]?.value || childCardInfo[columns[95].name]?.value) && 'accept-item'}`}>
                  {(cardInfo[columns[95].name]?.value || childCardInfo[columns[95].name]?.value) && (
                    <h4 className='text-black fw-normal mb-0'> Select Product Specific Options: </h4>
                  )}

                  {!isFromList && (childCardInfo[columns[95].name]?.value ? (
                    <div className="payment-terms">
                      <Select
                        className="payment-terms-selector h4 mb-0"
                        isMulti
                        options={
                          product_specific_options.map((option) => ({
                            label: option,
                            value: option.toLowerCase().replaceAll(' ', '-')
                          }))
                        }
                        value={childCardInfo[columns[96].name]}
                        isDisabled={true}
                      />
                    </div>
                  )
                    : <div></div>
                  )}

                  {cardInfo[columns[95].name].value ? (
                    <div className="payment-terms">
                      <Select
                        className="payment-terms-selector h4 mb-0"
                        isMulti
                        options={
                          product_specific_options.map((option) => ({
                            label: option,
                            value: option.toLowerCase().replaceAll(' ', '-')
                          }))
                        }
                        value={cardInfo[columns[96]?.name]}
                        onChange={(item) => onChangeCardInfo(columns[96]?.name, item)}
                      />
                    </div>
                  )
                    : <div></div>
                  }
                </div>

              </>
            )}
          <div className='advance-acceptance-details-btn create-master flex flex-column'>
            {Object.keys(deliveryMethodFeeValues).length > 0 && (
              <div className="flex align-center justify-space-between advanced-details-toggle-option">
                <h4 className='heading toggle-item-text text-white fw-bold mb-0'>Disable Advanced Acceptance</h4>
                <ToggleButton checked={!cardInfo[columns[48].name]?.value} onChange={(checked) => onChangeCardInfo(columns[48]?.name, { label: `${!checked}`, value: !checked })} />
              </div>
            )}
            {totalDeliveryMethods > 1 && (
              <button className='h4 text-white mb-0' onClick={() => { setShowAdvanceAccDetailsModal(!showAdvanceAccDetailsModal) }}> Go to Advanced Acceptance Detail </button>
            )}
          </div>
        </div>
      </div>
      {showAdvanceAccDetailsModal && (
        <AdvanceAcceptanceDetailsModal
          deliveryMethodTabs={deliveryMethodTabs}
          show={showAdvanceAccDetailsModal}
          onClose={handleCloseAdvanceAccDetailsModal}
          deliveryMethodValues={deliveryMethodValues}
          handleDeliveryMethodsChange={handleDeliveryMethodsChange}
          deliveryMethodFeeValues={deliveryMethodFeeValues}
          setDeliveryMethodsFeeValues={setDeliveryMethodsFeeValues}
        // alreadySetOptions={alreadySetOptions}
        />
      )}
      {showAddNewContact && (
        <>
          <ModalComponent size='xl' modalTitle='' open={showAddNewContact} handleClose={handleCreateContactClose} dialogClassName='px-5 create-new-contact-modal-dialog'>
            <CreateContact onClose={handleCreateContactClose} contactDataFromField={contactDataFromField} />
          </ModalComponent>
        </>
      )}
    </>
  )
}
export default CreateMasterCardTab